// ArChat Language Extension
// Created: 13-03-2026 00:30:00
// Author: SIVOL® - Aldo Frias - Argentina

import { translationsEn } from './translations.en.js';
import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsHe = {
  ...translationsEn,
  'common.loading': 'טוען…',
  'common.cancel': 'ביטול',
  'common.confirm': 'אישור',
  'common.close': 'סגור',
  'common.sending': 'שולח...',
  'common.language': 'שפה',
  'home.language': 'שפה',
  'app.install': 'התקנת ArChat',
  'login.title': 'התחברות',
  'register.pageTitle': 'יצירת חשבון',
  'onboarding.welcome_title': 'ברוכים הבאים ל-ArChat®',
  'onboarding.step1_description': 'הזמן את איש הקשר הראשון שלך',
  'onboarding.step2_description': 'שלח את ההודעה הראשונה שלך',
  'onboarding.explore_archat': 'גלה את ArChat®',
  'common.continue': 'המשך',
  'common.backToStart': 'חזרה לדף הבית',
  'auth.invalid_credentials': 'שם משתמש או סיסמה שגויים.',
  'auth.user_not_found': 'המשתמש לא נמצא.',
  'auth.user_inactive': 'החשבון שלך אינו פעיל. פנה למנהל המערכת.',
  'auth.captcha_failed': 'ה-CAPTCHA שגוי. בדוק את התשובה.',
  'auth.generic_error': 'אירעה שגיאה. נסה שוב.',
  'auth.password_mismatch': 'הסיסמאות אינן תואמות.',
  'auth.rate_limit': 'יותר מדי ניסיונות. המתן מעט ונסה שוב.',
  'contacts.no_contacts': 'אין אנשי קשר',
  'contacts.invite_contact': 'הזמן איש קשר',
  'contacts.empty.title': 'עדיין אין אנשי קשר',
  'contacts.empty.message': 'שלח הזמנה כדי להתחיל את השיחה הראשונה.',
  'contacts.empty.invite_button': 'הזמן איש קשר',
  'contacts.title': 'אנשי קשר',
  'contacts.search': 'חיפוש איש קשר',
  'contacts.sort': 'מיון',
  'contacts.sortByName': 'לפי שם',
  'contacts.sortByStatus': 'לפי סטטוס',
  'contacts.sortByRecent': 'אחרונים',
  'contacts.filter': 'סינון',
  'contacts.filterAll': 'הכל',
  'contacts.filterAvailable': 'זמינים',
  'contacts.filterInvited': 'הוזמנו',
  'contacts.filterBlocked': 'חסומים',
  'contacts.pending_invitations': 'הזמנות ממתינות',
  'contacts.status.invitation_sent': 'ההזמנה נשלחה',
  'contacts.conversations': 'שיחות',
  'contacts.search_contact': 'חיפוש איש קשר',
  'profile.title': 'הפרופיל שלי',
  'profile.edit': 'עריכה',
  'profile.save': 'שמור שינויים',
  'profile.cancel': 'ביטול',
  'profile.language': 'שפה',
  'menu.contacts': 'אנשי קשר',
  'navbar.contacts': 'אנשי קשר',
  'menu.dashboard': 'לוח בקרה',
  'menu.help': 'עזרה',
  'menu.logout': 'התנתקות',
  'menu.files': 'הקבצים שלי',
  'reviews.menu_title': 'ביקורות',
  'reviews.rate_archat': 'דרג את ArChat',
  'reviews.my_review': 'הביקורת שלי',
  'menu.profile': 'הפרופיל שלי',
  'menu.settings': 'הגדרות',
  'profile.my_profile': 'הפרופיל שלי',
  'profile.status': 'סטטוס',
  'profile.invite_email': 'הזמנת איש קשר באימייל',
  'profile.sent_invitations': 'הזמנות שנשלחו',
  'profile.users': 'משתמשים',
  'profile.settings': 'הגדרות',
  'profile.appearance': 'מראה',
  'profile.logout': 'התנתקות',
  'navbar.status': 'סטטוס',
  'status.available': 'זמין',
  'status.busy': 'עסוק',
  'status.in_call': 'בשיחה',
  'status.away': 'לא זמין',
  'status.offline': 'לא מחובר',
  'status.custom': 'הודעה מותאמת',
  'status.set_title': 'מצב זמינות',
  'status.set_button': 'שינוי מצב',
  'status.placeholder': 'הודעה אופציונלית (למשל: בפגישה)',
  'contacts.available': 'זמין',
  'invitation.title': 'הזמנת איש קשר',
  'invitation.modal.title': 'שליחת הזמנה',
  'invitation.modal.description': 'הזמן מישהו לשוחח איתך ב-ArChat®. הוא יקבל אימייל עם קישור לאישור ההזמנה.',
  'invitation.email.label': 'אימייל המוזמן',
  "invitation.email.placeholder": "ejemplo@email.com",
  'invitation.email.required': 'אימייל הוא שדה חובה',
  'invitation.email.invalid': 'נא להזין כתובת אימייל תקינה',
  'invitation.language.label': 'שפה מועדפת של המוזמן',
  'invitation.language.help': 'האימייל יישלח בשפה זו',
  'invitation.mode.label': 'מצב שיחה',
  'invitation.mode.profesional': 'מקצועי',
  'invitation.mode.profesional.description': 'שיחה רשמית ומקצועית',
  'invitation.mode.tecnico': 'טכני',
  'invitation.mode.tecnico.description': 'שיחה טכנית ומקצועית',
  'invitation.mode.casual': 'ידידותי',
  'invitation.mode.casual.description': 'שיחה לא רשמית וידידותית',
  'invitation.message.label': 'הודעה אישית (אופציונלי)',
  'invitation.message.placeholder': 'כתוב הודעה אישית למוזמן...',
  'invitation.send': 'שלח הזמנה',
  'invitation.sending': 'שולח...',
  'invitation.success': 'ההזמנה נשלחה בהצלחה',
  'invitation.success.title': 'ההזמנה נשלחה',
  'invitation.success.message': 'ההזמנה נשלחה בהצלחה.\n\nאיש הקשר יקבל אימייל עם קישור לאישור ההזמנה. לאחר האישור תוכלו להתחיל לשוחח.',
  'invitation.error': 'שגיאה בשליחת ההזמנה',
  'invitation.error.self': 'לא ניתן להזמין את עצמך',
  'invitation.error.duplicate': 'כבר קיימת הזמנה ממתינה עבור כתובת אימייל זו',
  'invitation.list.title': 'הזמנות שנשלחו',
  'invitation.list.empty': 'עדיין לא שלחת הזמנות',
  'invitation.list.email': 'אימייל',
  'invitation.list.language': 'שפה',
  'invitation.list.mode': 'מצב',
  'invitation.list.status': 'סטטוס',
  'invitation.list.created': 'נשלח',
  'invitation.list.expires': 'תפוגה',
  'invitation.list.actions': 'פעולות',
  'invitation.status.pending': 'ממתינה',
  'invitation.status.accepted': 'התקבלה',
  'invitation.status.expired': 'פג תוקף',
  'invitation.status.cancelled': 'בוטלה',
  'invitation.status.deleted': 'נמחקה',
  'invitation.status.rejected': 'נדחתה',
  'invitation.status.bounced': 'הוחזר',
  'invitation.status.unknown': 'לא ידוע',
  'invitation.deleted.tooltip': 'הזמנה זו נמחקה',
  'invitation.cancel': 'ביטול',
  'invitation.cancel.confirm': 'האם אתה בטוח שברצונך לבטל הזמנה זו?',
  'invitation.cancel.success': 'ההזמנה בוטלה בהצלחה',
  'invitation.cancel.title': 'אישור ביטול',
  'invitation.resend': 'שליחה חוזרת של אימייל',
  'invitation.resend.title': 'שליחת הזמנה מחדש',
  'invitation.resend.success': 'אימייל ההזמנה נשלח מחדש בהצלחה',
  'invitation.resend.error': 'שגיאה בשליחה מחדש של אימייל ההזמנה',
  'invitations.columns.mode': 'מצב',
  'invitations.actions.resend': 'שליחה חוזרת של אימייל',
  'invitations.actions.cancel': 'ביטול הזמנה',
  'invitations.pending.title': 'הזמנות ממתינות',
  'invitations.sent.title': 'הזמנות שנשלחו',
  'dashboard.title': 'לוח בקרה',
  'dashboard.planUsage': 'שימוש בתוכנית',
  'dashboard.filesSummary': 'הקבצים שלי',
  'dashboard.promotions': 'מבצעים',
  'dashboard.sessions': 'הפעלות פעילות',
  'dashboard.explore': 'גלה',
  'dashboard.noSessions': 'אין הפעלות פעילות',
  'dashboard.welcomeTitle': 'ברוכים הבאים ל־ArChat®',
  'dashboard.welcomeSubtitle': 'לתקשר בכל שפה.',
  'dashboard.stepInvite': 'שלב 1: הזמינו איש קשר ראשון',
  'dashboard.stepMessage': 'שלב 2: שלחו הודעה ראשונה',
  'dashboard.inviteContact': 'הזמנת איש קשר',
  'dashboard.exploreArChat': 'גילוי ArChat',
  'dashboard.promotionsTitle': 'מבצעים',
  'dashboard.promotionsText': 'סקירה של מבצעי הזמנות ומצטיינים.',
  'dashboard.viewPromotions': 'למבצעים',
  'dashboard.usageTitle': 'שימוש בתוכנית',
  'dashboard.sessionsTitle': 'הפעלות פעילות',
  'dashboard.sessionsEmpty': 'אין הפעלות פעילות',
  'dashboard.filesTitle': 'הקבצים שלי',
  'dashboard.viewFiles': 'לקבצים',
  'dashboard.noBlocks': 'אין בלוקים פעילים. הפעילו לפחות אחד בהגדרות.',
  'dashboard.openSettings': 'פתיחת הגדרות',
  'dashboard.goToContacts': 'מעבר לאנשי קשר',
  'dashboard.filesVisible': 'קבצים נראים',
  'dashboard.filesSampleNote': 'לפי עמוד ראשון (עד 500+).',
  'dashboard.card.contacts': 'אנשי קשר',
  'navbar.users': 'משתמשים',
  'contacts.controls.sort.name': 'שם',
  'contacts.controls.sort.recent': 'אחרונים',
  'contacts.controls.sort.manual': 'ידני',
  'contacts.controls.sort.manual_drag_hint': 'גרור לסידור מחדש',
  'contacts.controls.filter.all': 'הכל',
  'contacts.controls.filter.invited': 'הוזמנו',
  'contacts.controls.filter.blocked': 'חסומים',
  'contacts.controls.filter.favorites': 'מועדפים',
  'menu.open': 'תפריט',
  'contacts.controls.search_placeholder': 'חיפוש איש קשר...',
  'contacts.controls.search_label': 'חיפוש איש קשר',
  'contacts.controls.sort_label': 'מיון',
  'contacts.controls.filter_label': 'סטטוס',
  'contacts.controls.filter.available': 'זמינים',
  'contacts.controls.sort.status': 'סטטוס',
  'contacts.status': 'סטטוס',
  'contacts.controls.hide_non_favorites': 'הסתר אנשי קשר שאינם מועדפים',
  'contacts.controls.show_all': 'הצג את כל אנשי הקשר',
  'common.navigation': 'ניווט',
  'common.favorite': 'מועדף',
  'common.block': 'חסום',
  'common.user': 'משתמש',
  'message.new': 'הודעה חדשה',
  'message.edit': 'עריכת הודעה',
  'message.edit.save': 'שמור עריכה',
  'message.edit.cancel': 'בטל עריכה',
  'message.translating': 'מתרגם...',
  'message.translation_failed': 'התרגום נכשל',
  'message.not_translated': 'טקסט מקורי',
  'message.retry_send': 'נסה שוב',
  'message.retrying': 'מנסה שוב...',
  'message.delete': 'מחק הודעה',
  'message.deleted_placeholder': 'ההודעה נמחקה',
  'message.edited': 'נערך',
  'message.edited_at': 'נערך ב-',
  'message.delete_for_me.tooltip': 'מחק עבורי',
  'message.delete_for_me.aria': 'מחק הודעה זו עבורי בלבד',
  'message.delete_for_me.confirm_title': 'מחיקת הודעה',
  'message.delete_for_me.confirm_message': 'הודעה זו תימחק רק מהתצוגה שלך.',
  'message.delete_for_everyone.tooltip': 'מחק עבור כולם',
  'message.delete_for_everyone.aria': 'מחק הודעה זו עבור כל המשתתפים',
  'message.delete_for_everyone.confirm_title': 'מחיקת הודעה עבור כולם',
  'message.delete_for_everyone.confirm_message': 'הודעה זו תימחק עבורך ועבור המשתתף השני.',
  'message.delete_for_everyone.window_expired': 'חלון המחיקה פג',
  'message.translation.show': 'הצג מקור ותרגום',
  'message.translation.hide': 'הסתר תרגום',
  'emoji.search': 'חיפוש אימוג׳י',
  'emoji.close': 'סגור בוחר',
  'captcha.refresh': 'צור CAPTCHA מחדש',
  'presence.unavailable': 'הסטטוסים אינם זמינים',
  'presence.maintenance': 'השרת בתחזוקה',
  'presence.title': 'מצב נוכחות',
  'presence.currentStatus': 'מצב נוכחי:',
  'presence.changeStatus': 'שינוי מצב',
  'presence.status.online': 'מחובר',
  'presence.status.online.title': 'מחובר - גלוי לכולם',
  'presence.status.online.description': 'מחובר: גלוי לכל אנשי הקשר',
  'presence.status.idle': 'לא פעיל',
  'presence.status.idle.title': 'לא פעיל - מציין היעדרות זמנית',
  'presence.status.idle.description': 'לא פעיל: מציין שאינך זמין באופן זמני',
  'presence.status.dnd': 'נא לא להפריע',
  'presence.status.dnd.title': 'נא לא להפריע - מציין שאתה מעדיף לא להיות מופרע',
  'presence.status.dnd.description': 'נא לא להפריע: סימן נראה שאתה מעדיף לא להיות מופרע',
  'presence.status.busy': 'עסוק',
  'presence.status.busy.title': 'עסוק - לא זמין',
  'presence.status.busy.description': 'עסוק: לא זמין',
  'presence.status.offline': 'לא מחובר',
  'presence.status.offline.title': 'מנותק - להופיע כלא מחובר',
  'presence.status.offline.description': 'לא מחובר: להופיע כמנותק',
  'presence.status.custom': 'מותאם אישית',
  'presence.status.custom.title': 'מותאם אישית - מצב ייחודי עם אמוג׳י',
  'presence.status.custom.description': 'מותאם אישית: מצב ייחודי עם אמוג׳י ותוקף אופציונלי',
  'presence.custom.title': 'מצב מותאם אישית',
  'presence.custom.status': 'מצב מותאם אישית',
  'presence.custom.placeholder': 'לדוגמה: בהפסקת קפה ☕',
  'presence.custom.emoji': 'אמוג׳י (אופציונלי)',
  'presence.custom.emojiHelp': 'בחר אמוג׳י או הקלד אחד',
  'presence.custom.temporary': 'מצב זמני (פג אוטומטית)',
  'presence.custom.expiration': 'תאריך תפוגה',
  'presence.custom.expirationHelp': 'המצב יחזור ל"מחובר" עם סיום התוקף',
  'presence.custom.suggestions': 'הצעות',
  'presence.custom.preview': 'תצוגה מקדימה',
  'presence.custom.save': 'שמור מצב',
  'presence.custom.required': 'מצב מותאם אישית הוא שדה חובה',
  'presence.custom.maxLength': 'מקסימום 64 תווים',
  'presence.custom.expirationRequired': 'יש לבחור תאריך תפוגה',
  'presence.custom.expirationFuture': 'תאריך התפוגה חייב להיות בעתיד',
  'presence.custom.selectEmoji': 'בחירת אמוג׳י',
  'home.access_nav': 'גישה ליישום',
  'plan.free_characters_month': '30,000 תווים / לחודש',
  'plan.pro_characters_month': '300,000 תווים / לחודש',
  'suggestions.title': 'הצעות',
  'suggestions.form.title': 'כותרת ההצעה',
  'suggestions.form.message': 'תאר את הרעיון שלך',
  'suggestions.form.submit': 'שלח הצעה',
  'suggestions.send': 'שלח הצעה',
  'suggestions.captcha_placeholder': 'תוצאה',
  'suggestions.cooldown': 'יש להמתין {minutes} דקות לפני שליחת הצעה נוספת.',
  'suggestions.success_title': 'ההצעה נשלחה',
  'suggestions.success_message': 'ההצעה שלך נשלחה בהצלחה. מספר מעקב: {id}',
  'suggestions.success': 'תודה על ההצעה שלך. הצוות שלנו יבדוק אותה.',
  'suggestions.success.title': 'תודה על ההצעה שלך!',
  'suggestions.success.reference': 'אסמכתא',
  'suggestions.success.review': 'הצוות שלנו יבדוק את הרעיון שלך.',
  'suggestions.success.email': 'שלחנו גם אימייל אישור.',
  'suggestions.success.copy': 'העתק',
  'suggestions.success.copied': 'האסמכתא הועתקה',
  'suggestions.form.required': 'כותרת והודעה הן שדות חובה.',
  'suggestions.error': 'לא ניתן לשלוח. נסה שוב.',
  'suggestions.sendSuccess': 'ההצעה שלך נשלחה בהצלחה.',
  'suggestions.sendError': 'לא ניתן היה לשלוח את ההצעה. נסה שוב.',
  'suggestions.sent': 'ההצעה נשלחה בהצלחה.',
  'suggestions.new': 'הצעה חדשה',
  'suggestions.empty': 'עדיין לא שלחת הצעות.',
  'suggestions.admin_note': 'הערת צוות',
  'suggestions.status.pending': 'בהמתנה',
  'suggestions.status.reviewed': 'נבדקה',
  'suggestions.status.planned': 'בתכנון',
  'suggestions.status.implemented': 'יושמה',
  'suggestions.status.rejected': 'נדחתה',
  'errors.suggestionSend': 'לא ניתן היה לשלוח את ההצעה. נסה שוב.',
  'help.title': 'עזרה ArChat®',
  'help.howWorks.title': 'איך ArChat® עובד',
  'help.languages.title': 'שפות',
  'help.languages.point1': 'תמיכה ב-{count} שפות.',
  'help.languages.point2': 'בורר שפה חזותי עם דגלים.',
  'notifications.title': 'התראות',
  'notifications.empty': 'אין התראות',
  'errors.generic': 'אירעה שגיאה לא צפויה.',
  'errors.network': 'שגיאת חיבור. נסה שוב.',
  'errors.required': 'שדה זה הוא חובה.',
  'promotions.invite.message': 'אני מזמין אותך ל-ArChat — דבר בכל שפה. שנינו מרוויחים הטבות.',
  'promotions.progress.pending': 'יש לך הזמנות ממתינות כדי לפתוח תגמולים.',
  'promotions.progress.in_progress': 'ההזמנות שלך בתהליך: התגמולים יופעלו אחרי שיחה אמיתית.',
  'promotions.progress.remaining': 'חסרה לך עוד {count} שיחה כדי לקבל את התגמול.',
  'promotions.progress.sent_count': 'נשלחו',
  'promotions.progress.pending_count': 'ממתינות',
  'promotions.progress.in_progress_count': 'בתהליך',
  'promotions.progress.completed_count': 'הושלמו',
  'promotions.banner.empty': 'התחל עכשיו: הזמן אנשי קשר ופתח הטבות.',
  'promotions.banner.pending': 'יש לך הזמנות ממתינות: השלם שיחה אמיתית וקבל תגמולים.',
  'promotions.banner.reward': 'כבר פתחת תגמולים! המשך להזמין כדי להגדיל את הרווחים.',
  'promotions.cta.copy': 'העתק הודעה וקישור',
  'promotions.cta.copied': 'ההודעה הועתקה',
  'promotions.cta.copy_error': 'לא ניתן היה להעתיק את ההודעה',

  'promotions.title': 'מבצעים ותגמולים',
  'promotions.subtitle': 'הזמן אנשי קשר ופתח הטבות דרך שימוש אמיתי.',
  'promotions.how_it_works': 'איך זה עובד',
  'promotions.step1': 'הזמן איש קשר מהפרופיל שלך.',
  'promotions.step2': 'כשהוא מקבל ומשוחח באינטראקציה אמיתית, האימות מתבצע אוטומטית.',
  'promotions.step3': 'התגמול מזוכה וההתקדמות שלך מתעדכנת.',
  'promotions.rewards.title': 'תגמולים',
  'promotions.reward.invite': 'תגמול על כל הפניה מאומתת.',
  'promotions.reward.milestone': 'בונוסים על אבני דרך בצמיחה.',
  'promotions.reward.ranking': 'נראות בדירוג בוני הרשת המובילים.',
  'promotions.progress.title': 'ההתקדמות שלך',
  'promotions.progress.sent': 'נשלחו',
  'promotions.cta.invite': 'הזמן איש קשר',
  'promotions.banner': 'הפעל מבצעים: הזמן וקבל תגמולים על שימוש אמיתי.',
  'promotions.modal.title': 'תוכנית מבצעים',
  'promotions.modal.body': 'קבל +10.000 תווים לכל הזמנה מאומתת.\\\\nהזמן היום ופתח תגמולים.',
  'promotions.modal.cta': 'צפה במבצעים',
  'login.slogan': 'שיחות בלי גבולות!',
  'login.username': 'שם משתמש',
  'login.password': 'סיסמה',
  'login.submit': 'כניסה',
  'login.loading': 'טוען...',
  'login.autoRegister.title': 'הרשמה אוטומטית',
  'login.autoRegister.description': 'אם אין לך חשבון, הזן שם משתמש, סיסמה ודוא\"ל. החשבון ייווצר אוטומטית ותקבל קישור אישור בדוא\"ל.',
  'login.forgotPassword': 'שכחת סיסמה?',
  'login.passwordRecovery.title': 'שחזור סיסמה',
  'login.passwordRecovery.description': 'הזן את הדוא\"ל שלך כדי לקבל קישור שחזור.',
  'login.passwordRecovery.emailLabel': 'דוא\"ל',
  'login.passwordRecovery.emailPlaceholder': 'הזן את הדוא\"ל שלך',
  'login.passwordRecovery.emailHelp': 'קישור שחזור יישלח לדוא\"ל שלך',
  'login.passwordRecovery.send': 'שליחה',
  'login.passwordRecovery.success': 'נשלח קישור שחזור לדוא\"ל שלך. בדוק את תיבת הדואר הנכנס.',
  'login.passwordRecovery.successTitle': 'הדוא\"ל נשלח',
  'login.passwordRecovery.successMessage': 'שלחנו לך דוא\"ל עם הוראות לאיפוס הסיסמה.\nבדוק את תיבת הדואר הנכנס ותיקיית הספאם. ייתכן שהקישור יגיע תוך כמה דקות.',
  'login.passwordRecovery.devExplanation': 'במצב פיתוח הדוא\"ל לא נשלח לתיבה; הוא נשמר לתצוגה מקדימה. השתמש ב\"צפה בדוא\"ל\" כדי לראות את התוכן ואת הקישור.',
  'login.passwordRecovery.devSinkNotice': '⚠️ מצב פיתוח: דוא\"ל זה לא נשלח לתיבה שלך. השתמש ב\"צפה בדוא\"ל\" כדי לפתוח את ההודעה ולהשתמש בקישור.',
  'login.passwordRecovery.invalidEmail': 'נא להזין כתובת דוא\"ל תקינה',
  'login.error.invalidPassword': 'סיסמה לא תקינה',
  'auth.require_email': 'נדרש דוא\"ל להשלמת ההרשמה. נא להזין את כתובת הדוא\"ל שלך.',
  'auth.tenant_mismatch': 'החשבון שלך אינו שייך לסביבה זו. צור קשר עם המנהל.',
  'auth.account_blocked': 'החשבון לא פעיל. הזן את הדוא\"ל שלך כדי להפעיל אותו מחדש.',
  'auth.device_limit_reached': 'הגעת למגבלת המכשירים. התנתק במכשיר אחר או שדרג את התוכנית.',
  'auth.login.device_limit.title': 'הגעת למגבלת ההפעלות או המכשירים',
  'auth.login.device_limit.body': 'התוכנית שלך מאפשרת מספר מוגבל של הפעלות או מכשירים פעילים. כדי להיכנס, התנתק במכשיר אחר או סגור הפעלה פעילה אחרת ונסה שוב.',
  'auth.password_incorrect': 'הסיסמה שגויה.',
  'auth.login.password_error_title': 'סיסמה שגויה',
  'auth.login.password_attempts_hint': 'יש לך 3 ניסיונות להזין את הסיסמה נכון. אם תעבור אותם, תצטרך לאפס את הסיסמה.',
  'auth.login.password_attempts_exhausted_title': 'הגעת למגבלת הניסיונות',
  'auth.login.password_attempts_exhausted_body': 'עברת את 3 הניסיונות המותרים. כדי להמשיך, אפס את הסיסמה דרך «שכחת סיסמה?».',
  'auth.login.go_to_reset_password': 'מעבר לאיפוס סיסמה',
  'auth.login.password_remaining_two': 'נותרו לך 2 ניסיונות.',
  'auth.login.password_remaining_one': 'נותר לך ניסיון אחד.',
  'auth.login.password_attempts_locked_inline': 'הגעת למספר הניסיונות המקסימלי. עליך לאפס את הסיסמה.',
  'auth.account_inactive_email_mismatch': 'החשבון לא פעיל והדוא\"ל אינו תואם.',
  'auth.captcha_expired': 'פג תוקף האימות שלך. נוצר אימות חדש אוטומטית.',
  'auth.captcha_required': 'נא להשלים את אימות האבטחה (CAPTCHA).',
  'auth.unauthorized': 'אין לך הרשאת גישה.',
  'auth.method_not_allowed': 'שיטה לא מותרת.',
  'auth.invalid_data': 'נתונים לא תקינים.',
  'auth.credentials_required': 'נדרשים שם משתמש וסיסמה.',
  'auth.csrf_invalid': 'הפעלה לא תקינה. טען מחדש את הדף ונסה שוב.',
  'auth.username_taken': 'שם המשתמש כבר רשום. היכנס או בחר שם אחר.',
  'auth.username_unavailable': 'שם המשתמש אינו זמין.',
  'auth.nick_no_spaces': 'כינויים לא יכולים להכיל רווחים.',
  'auth.password_too_short': 'הסיסמה חייבת להכיל לפחות 6 תווים.',
  'auth.confirm_success': 'החשבון אושר. מפנה לכניסה...',
  'auth.confirm_already_active': 'החשבון שלך כבר פעיל. אתה יכול להיכנס.',
  'auth.reset_sent': 'אם הדוא\"ל רשום, תקבל הוראות לאיפוס הסיסמה.',
  'auth.reset_token_invalid': 'קישור לא תקין או חסר.',
  'auth.reset_token_expired': 'פג תוקף הקישור. בקש חדש דרך «שכחת סיסמה?».',
  'auth.reset_done': 'הסיסמה עודכנה. כעת תוכל להיכנס.',
  'auth.reset_fatal': 'שגיאה בשמירה. נסה שוב מאוחר יותר.',
  'resetPassword.page.title': 'סיסמה חדשה',
  'resetPassword.page.description': 'הזן את הסיסמה החדשה שלך (לפחות 6 תווים).',
  'resetPassword.newPassword': 'סיסמה חדשה',
  'resetPassword.newPasswordPlaceholder': 'לפחות 6 תווים',
  'resetPassword.submit': 'איפוס סיסמה',
  'resetPassword.success': 'הסיסמה עודכנה. מפנה לכניסה...',
  'resetPassword.backToLogin': 'חזרה לכניסה',

  'account.delete.section_title': 'מחיקת חשבון',
  'account.delete.description': 'מחיקת החשבון תסיר לצמיתות את כל הנתונים, ההודעות, אנשי הקשר וההגדרות. לא ניתן לבטל פעולה זו.',
  'account.delete.button': 'מחק את החשבון שלי',
  'accountDeletion.title': 'מחיקת חשבון ונתונים',
  'accountDeletion.description': 'בקשו את מחיקת חשבון ArChat והנתונים הקשורים.',
  'accountDeletion.openRequest': 'בקשת מחיקת חשבון ונתונים',
  'account.delete.confirm_title': 'מחיקת חשבון',
  'account.delete.confirm_message': 'האם אתה בטוח שברצונך למחוק את החשבון? יישלח אימייל אישור לתיבת הדואר. המחיקה היא קבועה ובלתי הפיכה.',
  'account.delete.email_sent_title': 'האימייל נשלח',
  'account.delete.email_sent': 'שלחנו אימייל אישור. בדוק את תיבת הדואר הנכנס ולחץ על הקישור לאישור המחיקה.',
  'account.delete.error': 'לא ניתן לעבד את הבקשה. נסה שוב.',
  'account.delete.confirm_page_title': 'אשר מחיקת חשבון',
  'account.delete.confirm_page_desc': 'אתה עומד למחוק לצמיתות את חשבון ArChat. כל הנתונים, ההודעות, אנשי הקשר וההגדרות יוסרו. לא ניתן לבטל פעולה זו.',
  'account.delete.confirm_final_button': 'כן, מחק את החשבון שלי לצמיתות',
  'account.delete.cancel_go_back': 'ביטול וחזרה',
  'account.delete.done_title': 'החשבון נמחק',
  'account.delete.done_message': 'החשבון נמחק בהצלחה. כל הנתונים הוסרו.',
  'account.delete_token_expired': 'קישור המחיקה פג תוקף או אינו תקף. בקש חדש מהפרופיל.',
  'account.delete_token_invalid': 'קישור מחיקה לא תקין או חסר.',
  'account.delete_email_failed': 'לא ניתן לשלוח אימייל אישור. נסה מאוחר יותר.',
  'account.delete_error': 'שגיאה בעיבוד המחיקה. נסה מאוחר יותר.',

  'mail.send_failed': 'לא ניתן לשלוח דוא\"ל שחזור. בדוק את הגדרות SMTP או נסה מאוחר יותר.',
  'auth.register_success_email_sent': 'החשבון נוצר בהצלחה. נשלח דוא\"ל אישור. בדוק את תיבת הדואר (כולל ספאם) ולחץ על הקישור להפעלת החשבון.',
  'auth.register_success_email_pending': 'החשבון נוצר, אך אירעה בעיה בשליחת דוא\"ל האישור. אסימון ההפעלה עדיין תקף. צור קשר עם המנהל או בקש דוא\"ל אישור חדש.',
  'auth.email_not_verified': 'יש לאשר את הדוא\"ל כדי להפעיל את החשבון.',
  'auth.email_not_verified_title': 'החשבון ממתין לאישור',
  'auth.email_send_failed': 'לא הצלחנו לשלוח את הדוא\"ל. נסה שוב או שנה את כתובת הדוא\"ל.',
  'auth.email_send_failed_title': 'לא ניתן לשלוח דוא\"ל',
  'auth.register.email_failed.title': 'החשבון נוצר',
  'auth.register.email_failed.message': 'החשבון נוצר בהצלחה, אך אירעה בעיה בשליחת דוא\"ל האישור. בדוק ספאם או בקש דוא\"ל חדש.',
  'auth.register.success.title': 'החשבון נוצר',
  'auth.register.success.message': 'החשבון נוצר בהצלחה. נשלח דוא\"ל אישור. בדוק את תיבת הדואר (כולל ספאם) ולחץ על הקישור להפעלת החשבון.',
  'auth.resend_sent': 'דוא\"ל האישור נשלח שוב.',
  'auth.resend_activation': 'שליחה חוזרת של דוא\"ל הפעלה',
  'auth.resend_email': 'שליחת דוא\"ל שוב',
  'auth.retry_resend': 'נסה שוב',
  'auth.change_email': 'שנה דוא\"ל',
  'auth.ver_email': 'צפה בדוא\"ל',
  'auth.already_verified': 'החשבון כבר מאומת.',
  'auth.confirm_email_title': 'אשר דוא\"ל',
  'auth.confirm_email_text': 'קישור ההפעלה יישלח אל:',
  'auth.confirm_email_edit': 'עריכה',
  'auth.confirm_email_confirm': 'אישור',
  'auth.confirm_email_typo_hint': 'האם התכוונת ל-***@{suggestion}?',
  'brand.slogan': 'כוחה של הבנה — בכל שפה',
  "brand.appName": "ArChat®",
  "brand.name": "ArChat®",
  "home.title": "ArChat®",
  'home.slogan': 'כוחה של הבנה — בכל שפה',
  'home.tagline': 'הודעות עם תרגום אוטומטי',
  'home.login': 'כניסה',
  'home.register': 'יצירת חשבון',
  'terms.title': 'תנאים והגבלות',
  'terms.accept': 'קבל והמשך',
  'terms.reject': 'דחייה',
  'terms.rejectShort': 'אני לא מקבל',
  'terms.readAndAccept': 'קראתי ואני מקבל את התנאים וההגבלות',
  'terms.cancel': 'ביטול',
  'register.pageSubtitle': 'הזן את פרטיך ליצירת חשבון.',
  'register.submitLabel': 'יצירת חשבון',
  'register.confirm_title': 'אישור חשבון',
  'register.confirm_message': 'אתה עומד ליצור את החשבון:',
  'register.confirm': 'אישור',
  'register.creatingAccount': 'יוצר את החשבון…',
  'register.login_link': 'כבר יש לך חשבון?',
  'register.password_hint': 'לפחות 6 תווים',
  'register.checking': 'בודק…',
  'register.username_taken': 'שם המשתמש כבר בשימוש.',
  'register.available': 'זמין',
  'register.emailAlreadyExists': 'כתובת הדוא\"ל כבר רשומה.',
  'register.continue': 'המשך',
  'login.demo.title': 'גישת הדגמה',
  'login.demo.credentials': 'משתמש: demo / סיסמה: demo',
  'login.email.placeholder': 'הזן דוא\"ל לאישור החשבון',
  'login.email.help': 'קישור אישור יישלח לדוא\"ל שלך',
  'app.install_ios_hint': 'להתקנה: שיתוף > הוסף למסך הבית',
  'common.edit': 'עריכה',
  'common.on': 'פועל',
  'common.off': 'כבוי',
  'common.back': 'חזרה',
  'common.changeUser': 'החלפת משתמש',
  'common.refresh': 'רענון',
  'common.request_id_label': 'מזהה בקשה',
  'login.email.invalid': 'נא להזין דוא\"ל תקין',
  'system.processing': 'מעבד...',
  'captcha.solve': 'פתור את ה-CAPTCHA נכון',
  'captcha.generateError': 'שגיאה ביצירת CAPTCHA. טען מחדש את הדף.',
  'captcha.label': 'אימות אבטחה',
  'security.verification_title': 'אימות אבטחה',
  'security.captcha_question': 'שאלת אימות',
  'security.enter_answer': 'הזן את התשובה',
  'captcha.description': 'פתור את הפעולה כדי להמשיך.',
  'captcha.required': 'יש להזין את תשובת ה-CAPTCHA כדי להמשיך.',
  'captcha.incorrect': 'תשובת ה-CAPTCHA שגויה.',
  'captcha.placeholder': 'הזן את התשובה',
  'captcha.questionFormat': 'כמה זה {a} + {b}?',
  'menu.conversations': 'שיחות',
  'menu.admin': 'ניהול',
  'menu.promotions': 'מבצעים',
  "navbar.profile": "הפרופיל שלי",
  "navbar.settings": "תְצוּרָה",
  "navbar.logout": "לָצֵאת",
  'navbar.no_blocked_users': 'אין משתמשים חסומים',
  'navbar.blocked_users_title': 'משתמשים חסומים',
  'contacts.blocked_users_title': 'משתמשים חסומים',
  'contacts.country_label': 'מדינה',
  'contacts.not_reported': 'לא דווח',
  "navbar.user_fallback": "משתמש {id}",
  "navbar.open_guide": "מַדְרִיך",
  "help.view_initial_guide": "ראה מדריך ראשוני",
  "help.how_archat_works": "איך ArChat® עובד",
  "help.registration": "רְשׁוּמָה",
  "help.private_invitations": "הזמנות פרטיות",
  "help.messaging": "הודעות",
  "help.security": "בִּטָחוֹן",
  "invitation.quick_button": "הזמן איש קשר",
  "onboarding.title": "ברוכים הבאים ל-ArChat®",
  "onboarding.subtitle": "צור קשר עם כל אחד בכל שפה.",
  "onboarding.step1.label": "שלב 1",
  "onboarding.step1.text": "הזמן את איש הקשר הראשון שלך",
  "onboarding.step2.label": "שלב 2",
  "onboarding.step2.text": "שלח את ההודעה הראשונה שלך",
  "onboarding.actions.invite": "הזמן איש קשר",
  "onboarding.actions.explore": "חקור את ArChat®",
  "onboarding.welcome_subtitle": "צור קשר עם כל אחד בכל שפה.",
  "onboarding.step1": "שלב 1",
  "onboarding.step1_title": "שלב 1",
  "onboarding.step2": "שלב 2",
  "onboarding.step2_title": "שלב 2",
  "onboarding.invite_contact": "הזמן איש קשר",
  "referral.promo": "הזמן וזכה ב-10,000 תווים",
  "referral.stats.sent": "נשלח",
  "referral.stats.accepted": "מְקוּבָּל",
  "referral.stats.rewards": "תגמולים",
  "referral.reward.pending": "עָגִיל",
  "referral.reward.granted": "מְמוּלָא",
  "referral.reward.invalid": "לֹא בְּתוֹקֶף",
  "referral.reward.in_progress": "בשימוש",
  "referral.limit.reached": "הגעת למגבלת התגמול",
  "referral.waiting.usage": "+10,000 תווים כל אחד כאשר אתה והאורח שלך שולחים לפחות הודעת טקסט אמיתית אחת באותו צ'אט (אומת שרת).",
  "common.avatar": "גִלגוּל",
  "common.requiredFields": "מלא את כל השדות הנדרשים.",
  "bio.view": "ראה ביוגרפיה",
  "profile.founderBadge": "מייסד #{position}/{limit}",
  "profile.founderTooltip": "חבר מייסד - המחיר מוקפא לכל החיים כל עוד המנוי נשאר פעיל",
  "profile.founderMember": "חבר מייסד",
                'profile.founderHeaderBadge': '★ מייסד #{position}/150',
                'profile.camera.access_denied': 'לא ניתן לגשת למצלמה. בדוק הרשאות.',
  "profile.save.success": "הפרופיל שלך עודכן בהצלחה.",
  "profile.save.success.title": "פרופיל מעודכן",
  "profile.update.success.title": "פרופיל מעודכן",
  "profile.update.success.message": "השינויים שלך נשמרו בהצלחה.",
  "profile.save.error": "לא ניתן היה לעדכן את הפרופיל. אנא נסה שוב.",
  "profile.save.error.title": "שגיאת שמירה",
  "profile.nick": "שֵׁם מִשׁתַמֵשׁ",
  "profile.nick.help": "המזהה הייחודי שלך במערכת",
  "profile.nick.readonly": "לא ניתן לשנות את שם המשתמש",
  "profile.nick.readonly.help": "שם המשתמש הוא ייחודי ולא ניתן לשנותו",
  "profile.email.readonly": "לא ניתן לשנות את המייל",
  "profile.email.readonly.help": "המייל הוא ייחודי ולא ניתן לשנותו",
  "profile.name": "שם אמיתי",
  "profile.lastname": "שֵׁם מִשׁפָּחָה",
  "profile.alias": "כינוי",
  "profile.email": "אֶלֶקטרוֹנִי",
  "profile.phone": "טֵלֵפוֹן",
  "profile.country": "מְדִינָה",
  "profile.country.select": "בחר מדינה",
  "profile.biography": "בִּיוֹגְרַפִיָה",
  'bio.modal.original': 'מקור',
  'bio.modal.translation': 'תרגום',
  'bio.modal.empty': 'לאיש קשר זה אין ביוגרפיה.',
  'bio.modal.translating': 'מתרגם...',
  'bio.modal.translation_error': 'לא ניתן לתרגם את הביוגרפיה.',
  'attachment.unnamed_file': 'קובץ',
  'auth.login_error.default_title': 'שגיאת גישה',
  'auth.login_error.default_message': 'לא ניתן להתחבר.',
  "profile.photo": "תמונת פרופיל",
                'notifications.bell.aria': 'התראות',
                'notifications.panel.title': 'התראות',
                'notifications.empty': 'אין התראות',
                'notifications.mark_read': 'סמן כנקרא בפתיחה',
  'profile.notifications.sound': 'Notification sound',
  "profile.notifications.sound_desc": "השמע צליל כשמגיעות הודעות או התראות חשובות",
  "profile.invitations.title": "הזמנות",
  "profile.invitations.validated": "הזמנות מאומתות",
  "profile.invitations.nextBadge": "ההישג הבא",
  "profile.invitations.progress": "הִתקַדְמוּת",
  "profile.invitations.achievement": "הֶשֵׂג",
  "profile.invitations.topInviterAchieved": "הגעת למקסימום מזמין",
  "profile.invitations.badges.networkBuilder": "בונה רשתות",
  "profile.invitations.badges.topInviter": "מקסימום מזמין",
  "profile.invitations.achievement.networkBuilderMessage": "הזמנת 20 משתמשים ב-ArChat.",
  "profile.invitations.achievement.topInviterMessage": "הזמנת 50 משתמשים ב-ArChat.",
  "profile.plan.title": "תוכנית מנוי",
  "profile.plan.current": "התוכנית הנוכחית שלך",
  "profile.plan.expires": "יפוג",
  "profile.plan.loading_info": "טוען מידע על התוכנית...",
  "profile.plan.valid_until": "תקף עד:",
  "profile.plan.active_since": "פעיל מאז:",
  "profile.plan.active_badge": "✓ פעיל",
  'profile.plan.free.description': 'Free plan with limitations. Upgrade to PRO for full access.',
  'profile.plan.pro.description': 'You have full access to all features.',
  "profile.plan.upgrade.button": "שדרג ל-PRO",
  'profile.plan.upgrade.hint': 'Access all features without limits',
  "profile.manage_plan": "נהל תוכנית",
  "plan.current_plan": "תוכנית נוכחית",
  "plan.current": "Actual",
  'plan.footer_prefix': 'תוכנית:',
  "plan.upgrade_to_pro": "שדרג ל-PRO",
  "plan.upgrade_to_foundation": "שדרג ל-FOUNDATION",
  "plan.payment_coming": "תשלום באמצעות Paddle יהיה זמין בקרוב. אתה יכול לשנות תוכניות מכאן.",
  "plan.payment_coming_title": "בְּקָרוּב",
  "plan.foundation_full": "מכסת ה-FOUNDATION מלאה (150 מייסדים). אתה יכול לבחור PRO.",
  "plan.sold_out": "תָשׁוּשׁ",
  "plan.founder_spots_remaining": "רק {count} מקומות זמינים",
  "plan.founders_occupied": "מייסדים עסוקים",
  "plan.upgrade_not_allowed": "רק משתמשים עם תוכנית בחינם יכולים לבקש שדרוג.",
  'plan.free_contacts': 'עד 2 אנשי קשר',
  "plan.free_no_files": "Sin archivos",
  "plan.free_retention": "Historial 30 días",
  "plan.pro_files": "Archivos hasta 50MB",
  "plan.pro_export": "Exportación",
  "plan.founder_support": "Prioridad soporte",
  "plan.founder_badge": "Badge fundador",
  "founder.title": "FOUNDATION (מייסד)",
  "founder.subtitle": "אתה תומך בפרויקט מההתחלה במחיר לכל החיים.",
  "founder.whatIs": "150 המשתמשים הראשונים מקבלים את תוכנית FOUNDATION במחיר מוזל לכל החיים.",
  "founder.howItWorks": "רמת המייסד שלך תלויה במיקום שלך (1 עד 150).",
  "founder.benefitsTitle": "הטבות",
  'founder.benefitPrice': '$15 לחודש (תעריף Founder)',
  "founder.benefitFeatures": "כולל את כל התכונות של תוכנית PRO.",
  "founder.limit": "יש רק 150 מקומות מייסד.",
  "founder.cancelRule": "אם תבטל, תאבד את סטטוס המייסד בזמן שאתה מבטל את המנוי.",
  "founder.rejoinRule": "אם יש שוב מקום פנוי, תוכל להפעיל אותו מחדש ולהפוך שוב למייסד באופן אוטומטי.",
  "founder.tiers.title": "רמות מייסד",
  "founder.tiers.legendary.name": "מייסד אגדי",
  "founder.tiers.legendary.range": "עמדה 1–25",
  "founder.tiers.legendary.desc": "הראשון שתמך בפרויקט. עדיפות היסטורית מרבית.",
  "founder.tiers.early.name": "מייסד מוקדם",
  "founder.tiers.early.range": "עמדה 26–75",
  "founder.tiers.early.desc": "תמיכה מוקדמת עם הכרה מיוחדת.",
  "founder.tiers.founder.name": "מְיַסֵד",
  "founder.tiers.founder.range": "עמדה 76–150",
  "founder.tiers.founder.desc": "מכסת מייסדים בתוך 150 מקומות.",
  "founder.whatIsLink": "מה זה מייסד?",
  "founder.viewTiers": "ראה רמות מייסד",
  'billing.change_plan': 'שינוי תוכנית',
  "billing.usage.title": "תכנן שימוש",
  "billing.usage.users": "משתמשים",
  "billing.usage.messages": "הודעות (היום)",
  "billing.usage.invitations": "הזמנות (היום)",
  "billing.usage.messages_month": "הודעות החודש",
  "billing.usage.chats": "שיחות",
  "billing.usage.contacts": "אנשי קשר",
  "billing.usage.chars_month": "דמויות לחודש",
  "billing.usage.storage": "אחסון משומש",
  "billing.usage.devices": "מכשירים מחוברים",
  'billing.usage.warning': 'You are approaching your plan limit. Upgrade to PRO for more capacity.',
  'plans.limit.reached': 'הגעת למגבלה — שדרוג תוכנית',
  "billing.loading": "טְעִינָה...",
  'billing.subscription.section_title': 'מנוי וחיוב',
  'billing.subscription.provider_note': 'ספק',
  'billing.subscription.paddle_active': 'Paddle (תוכנית פעילה באפליקציה)',
  'billing.subscription.mp_action_ok': 'הבקשה נרשמה. אם התשלום לא נפתח, בדקו חיבור או נסו שוב.',
  'billing.paddle.manage_subscription_button': 'ניהול מנוי',
  'billing.paddle.portal_confirm_title': 'פורטל חיוב',
  'billing.paddle.portal_confirm': 'ייפתח פורטל Paddle מאובטח לעדכון אמצעי תשלום, חשבוניות או ביטול מנוי. להמשיך?',
  'billing.paddle.portal_opened_hint': 'פורטל Paddle נפתח בלשונית חדשה. רעננו את הפרופיל אם התוכנית לא התעדכנה.',
  'billing.paddle.portal_error': 'לא ניתן לפתוח את פורטל Paddle. נסו שוב מאוחר יותר או פנו לתמיכה.',
  'billing.paddle.no_link_error': 'אין עדיין קישור מנוי Paddle לחשבון. אם זה עתה שילמתם, המתינו ל-webhook או פנו לתמיכה.',
  'billing.paddle.api_not_configured': 'בשרת חסרה הגדרת Paddle API (PADDLE_API_KEY). מנהל המערכת חייב להגדיר.',
  "billing.descriptions.contacts": "סך כל אנשי הקשר המאוחסנים בחשבונך",
  "billing.descriptions.storage": "אחסון המשמש לקבצים ומדיה",
  "billing.descriptions.chars_month": "דמויות שתורגמו החודש",
  "billing.descriptions.devices": "מכשירים מחוברים פעילים",
  'billing.paddle.return_title': 'התשלום התקבל',
  'billing.paddle.return_body': 'אם השלמתם את התשלום, התוכנית תתעדכן זמן קצר לאחר אישור Paddle. ניתן לחזור לדף הבית.',
  'billing.paddle.verifying': 'בודקים את התוכנית…',
  'billing.paddle.not_logged_in': 'התחברו כדי לראות את סטטוס התוכנית המעודכן.',
  'billing.paddle.plan_updated': 'התוכנית עודכנה: {plan}',
  'billing.paddle.plan_current': 'התוכנית הנוכחית: {plan}',
  'billing.paddle.plan_current_founder': 'אתם כעת Founder — {plan}',
  'billing.paddle.still_free_hint': 'אם עדיין מופיע FREE אחרי רגע, ייתכן עיכוב ב-webhook. בדקו לוגים או רעננו את הדף.',
  'billing.paddle.pro_extra_hint': 'ניתן לחזור לדף הבית כדי להשתמש בתוכנית.',
  "profile.theme.dark": "מצב כהה",
  "profile.theme.light": "מצב נקה",
  "profile.theme.argentina": "נושא ארגנטינה",
  "modal.title": "הַכשָׁרָה",
  "modal.success.title": "הַצלָחָה",
  "modal.error.title": "טָעוּת",
  "modal.warning.title": "אַזהָרָה",
  "info.title": "מֵידָע",
  "appearance.title": "הוֹפָעָה",
  "appearance.theme.light": "בָּרוּר",
  "appearance.theme.dark": "כֵּהֶה",
  "theme.title": "לְהַנפִּיק",
  "theme.light": "בָּרוּר",
  "theme.dark": "כֵּהֶה",
  "profile.photo.section": "תמונת פרופיל",
  "profile.personalInfo": "מידע אישי",
  "profile.preferences": "העדפות",
  "profile.country.help": "אזור הזמן יוקצה אוטומטית על סמך המדינה שנבחרה",
  "profile.lastname.placeholder": "שם המשפחה שלך (אופציונלי)",
  "profile.name.placeholder": "השם האמיתי שלך (לא חובה)",
  "profile.biography.placeholder": "ספר לנו על עצמך...",
  "profile.photo.change": "שנה תמונת פרופיל",
  "message.placeholder": "כתוב הודעה...",
  "message.placeholderWithFile": "שלח קובץ",
  "message.sent_from_country": "נשלח מ",
  "message.sent_at_local_time": "הזמן המקומי של המנפיק",
  "message.timezone_label": "אזור זמן",
  "message.context_info": "הודעה זו משמרת את הקשר הזמן של הזמן שבו נשלחה.",
  "message.context_pro_hint": "להודעה זו יש זמן והקשר גיאוגרפי זמינים בתוכניות Pro.",
  "message.context_pro_badge": "Context Pro",
  "messages.empty": "אין עדיין הודעות",
  "messages.loading": "טוען הודעות...",
  "messages.connecting_server": "מתחבר לשרת ההודעות...",
  "messages.pending_send_count": "{count} הודעות ממתינות למשלוח",
  "attachment.title": "צרף קובץ",
  "attachment.close": "לִסְגוֹר",
  "attachment.gallery": "גלריית תמונות/סרטונים",
  "attachment.cameraFront": "מצלמה קדמית",
  "attachment.cameraBack": "מצלמה אחורית",
  "attachment.cameraWeb": "מצלמת אינטרנט",
  "attachment.selectFile": "בחר קובץ (PDF, טקסט, תמונות, סרטונים)",
  "attachment.remove": "לְחַסֵל",
  'attachments.recipientFreeBlocked.title': 'מגבלת התוכנית',
  'attachments.recipientFreeBlocked.sender': 'למשתמש יש תוכנית Free והוא לא יכול לקבל קבצים מצורפים.',
  'attachments.recipientFreeBlocked.receiver': '{senderName} ניסה לשלוח לך קובץ מצורף, אך תוכנית ה-{planName} שלך לא מאפשרת לקבל קבצים מצורפים. מומלץ לשדרג כדי לקבל קבצים.',
  'attachments.recipientFreeBlocked.upgradeCta': 'שדרוג תוכנית',
  "attachment.audioNotSupported": "הודעות שמע אינן נתמכות ב-ArChat®. נא לשלוח הודעה בכתב.",
  "message.audioDeprecated.title": "הודעה קולית אינה נתמכת",
  "message.audioDeprecated.message": "הודעה קולית זו אינה נתמכת עוד על ידי ArChat®. נא לשלוח הודעה בכתב.",
  "camera.title": "מַצלֵמָה",
  "camera.close": "לִסְגוֹר",
  "camera.switch": "החלף מצלמה",
  "camera.capture": "צלם תמונה",
  "camera.loading": "מפעיל את המצלמה...",
  "camera.retry": "נסה שוב",
  "camera.error.access": "לא ניתן היה לגשת למצלמה. בדוק הרשאות.",
  "camera.error.permission": "הרשאות המצלמה נדחו. אנא אפשר גישה למצלמה בהגדרות הדפדפן שלך.",
  "camera.error.notFound": "לא נמצאה מצלמה זמינה.",
  "camera.error.busy": "המצלמה נמצאת בשימוש על ידי אפליקציה אחרת.",
  "camera.error.constraint": "לא ניתן לעמוד בהגבלות המצלמה.",
  "profile.photo.take": "צלם תמונה",
  "profile.photo.gallery": "בחר מתוך הגלריה",
  "profile.photo.select": "בחר תמונה",
  "profile.photo.select.gallery": "בחר מתוך הגלריה",
  "profile.photo.uploading": "מעלה תמונה...",
  "profile.photo.upload.success": "תמונת הפרופיל עודכנה בהצלחה",
  "profile.photo.upload.success.title": "תמונה מעודכנת",
  "profile.photo.upload.error": "שגיאה בהעלאת תמונת פרופיל. אנא נסה שוב.",
  "profile.photo.upload.error.title": "שגיאה בהעלאת תמונה",
  "avatar.errors.too_large": "התמונה גדולה מדי. גודל מקסימלי: 2MB.",
  "avatar.preview.title": "תצוגה מקדימה של אווטאר",
  "profile.avatar.error_title": "לא ניתן היה לעדכן את הדמות",
  "profile.avatar.error.title": "לא ניתן היה לעדכן את הדמות",
  "profile.avatar.error.size": "התמונה חורגת מהגודל המותר. המקסימום הוא 2 MB.",
  "profile.avatar.tooLarge.title": "תמונה גדולה מדי",
  "profile.avatar.tooLarge.message": "התמונה חורגת מהגודל המותר. המקסימום הוא 2 MB.",
  "profile.avatar.uploadError.title": "לא ניתן היה לעדכן את הדמות",
  "profile.avatar.uploadError.message": "הייתה בעיה בהעלאת התמונה. נסה שוב.",
  "profile.saveSuccess.title": "פרופיל מעודכן",
  "profile.saveSuccess.message": "השינויים שלך נשמרו בהצלחה.",
  "profile.avatar.file_too_large": "התמונה חורגת מהגודל המרבי המותר (2 MB).",
  "profile.avatar.file_too_large_hint": "בחר תמונה בהירה יותר או הקטן את גודלה ונסה שוב.",
  "profile.photo.take.front": "מצלמה קדמית",
  "profile.photo.take.back": "מצלמה אחורית",
  "profile.photo.take.webcam": "מצלמת אינטרנט",
  "profile.photo.camera.front": "מצלמה קדמית",
  "profile.photo.camera.back": "מצלמה אחורית",
  "profile.photo.camera.web": "מצלמת אינטרנט",
  "profile.photo.close": "לִסְגוֹר",
  "profile.photo.capture": "לִלְכּוֹד",
  "user.default": "מִשׁתַמֵשׁ",
  "logout.title": "לְאַשֵׁר",
  "logout.confirm": "האם אתה בטוח שאתה רוצה להתנתק?",
  "block.toggle_error": "לא ניתן היה לנעול או לבטל את הנעילה.",
  "contacts.search.placeholder": "חפש לפי שם משתמש, שם פרטי, שם משפחה, מדינה או שפה...",
  "contacts.empty": "אין אנשי קשר",
  "contacts.empty.private.message": "הפרופיל שלך פרטי. הזמן אנשי קשר להתחיל לשוחח בצ'אט.",
  "contacts.empty.private.invite_button": "הזמן איש קשר",
  "contacts.search.no_results": "לא נמצאו אנשי קשר",
  "contacts.search.clear": "הצג הכל",
  "contacts.nick": "שֵׁם מִשׁתַמֵשׁ",
  "contacts.name": "שֵׁם",
  "contacts.lastname": "שֵׁם מִשׁפָּחָה",
  "contacts.country": "מְדִינָה",
  "contacts.language": "שָׂפָה",
  "contacts.status.pending_registration": "ההרשמה בהמתנה",
  "contacts.status.registered": "אורח - רשום",
  "contacts.status.ready_to_chat": "מוכן לצ'אט",
  "contacts.status.active_conversation": "שיחה פעילה",
  "contacts.invitation.pending.title": "הזמנה בהמתנה",
  "contacts.invitation.pending.message": "הזמנה זו ממתינה לרישום. איש הקשר יקבל אימייל להשלמת הרישום שלו. לאחר ההרשמה, תוכל לשוחח איתו בצ'אט.",
  "contacts.error.no_registered": "איש הקשר עדיין לא רשום. המתן לסיום ההרשמה.",
  "contact.edit.title": "ערוך איש קשר",
  "contact.edit.alias.label": "כינוי מותאם אישית",
  "contact.edit.alias.placeholder": "לדוגמה: חואן מהעבודה",
  "contact.edit.alias.help": "שם זה יופיע במקום השם האמיתי",
  "contact.edit.nota.label": "הערה אישית",
  "contact.edit.nota.placeholder": "הוסף הערה לגבי איש קשר זה...",
  "contact.edit.nota.help": "הערות פרטיות גלויות רק לך",
  "contact.edit.error.noUser": "שגיאה: משתמש לא מזוהה",
  "contact.edit.error.noContactId": "שגיאה: לא ניתן לזהות איש קשר",
  "contact.edit.error.save": "שגיאה בשמירה",
  "contact.limit.title": "הגעת למגבלת אנשי הקשר",
  "contact.limit.message": "התוכנית החינמית מאפשרת עד 2 אנשי קשר לכל משתמש. אתה יכול לשדרג ל-FOUNDATION או PRO לקבלת קיבולת רבה יותר כאשר הטעינה מופעלת.",
  "contact.favorite.add": "הוסף למועדפים",
  "contact.favorite.remove": "הסר מהמועדפים",
  "contact.block.block": "לַחסוֹם",
  'contact.block.unblock': 'ביטול חסימה',
  "conversation.backToContacts": "חזור לאנשי קשר",
  "conversation.notFound": "השיחה לא נמצאה",
  "help.howWorks.step1.title": "1️⃣ הרשמה",
  "help.howWorks.step1.point1": "היכנס עם הכינוי והסיסמה שלך.",
  "help.howWorks.step1.point2": "אם אין לך חשבון, הוא נוצר באופן אוטומטי.",
  "help.howWorks.step1.point3": "אתה מקבל את התנאים וההגבלות בשפתך.",
  "help.howWorks.step1.point4": "אתה מאשר את חשבונך באימייל.",
  "help.howWorks.step2.title": "2️⃣ הזמנות פרטיות",
  "help.howWorks.step2.point1": "הזמן אנשי קשר בדוא\"ל מהפרופיל שלך.",
  "help.howWorks.step2.point2": "הגדר את השפה ואת מצב השיחה לפני התחלת ההפעלה.",
  "help.howWorks.step2.point3": "איש הקשר מקבל הזמנה פרטית.",
  "help.howWorks.step2.point4": "אתה יכול לראות אם זה: בהמתנה, רשום, מוכן לצ'אט",
  "help.howWorks.step2.point5": "לא מחפשים אנשי קשר, הם מוזמנים.",
  "help.howWorks.step2.point6": "לא מחפשים אנשי קשר, הם מוזמנים.",
  "help.howWorks.step3.title": "3️⃣ אנשי קשר ושיחות",
  "help.howWorks.step3.point1": "אנשי הקשר שלך מופיעים אוטומטית כאשר:",
  "help.howWorks.step3.point2": "לקבל הזמנה",
  "help.howWorks.step3.point3": "או שיש שיחה",
  "help.howWorks.step3.point4": "פַּחִית:",
  "help.howWorks.step3.point5": "סמן אותם כמועדפים ⭐",
  "help.howWorks.step3.point6": "להקצות להם כינויים מותאמים אישית",
  "help.howWorks.step3.point7": "להוסיף הערות פרטיות",
  "help.howWorks.step3.point8": "לחסום או לנהל אותם",
  "help.howWorks.step3.point9": "אין סדר יום ציבורי או משתמשים גלויים ללא הסכמה.",
  "help.howWorks.step4.title": "4️⃣ שליחת הודעות עם תרגום",
  "help.howWorks.step4.point1": "כתוב תמיד בשפה שלך.",
  "help.howWorks.step4.point2": "המערכת מתרגמת את ההודעה באופן אוטומטי.",
  "help.howWorks.step4.point3": "הנמען מקבל אותו בשפתו.",
  "help.howWorks.step4.point4": "אתה יכול לראות את התרגום מיושם.",
  "help.howWorks.step4.point5": "אם תרגום נכשל, ניסיון חוזר אוטומטית.",
  "help.howWorks.step4.point6": "ArChat® נותן עדיפות לבהירות ומשמעות, לא רק מהירות.",
  "help.privacy.title": "🔒 פרטיות ושליטה",
  "help.privacy.point1": "הפרופיל שלך פרטי כברירת מחדל.",
  "help.privacy.point2": "רק מי שאתה מזמין יכול לראות או לכתוב לך.",
  "help.privacy.point3": "החשיפה לציבור היא אופציונלית ומושבתת כברירת מחדל.",
  "help.privacy.point4": "בטיחות פעילה עם:",
  "help.privacy.point5": "CAPTCHA",
  "help.privacy.point6": "הגבלת שיעור",
  "help.privacy.point7": "טְבִיעַת אֶצבָּעוֹת",
  "help.privacy.point8": "אימות דוא\"ל",
  "help.privacy.point9": "השיחות שלך אינן ציבוריות או אינן אינדקס.",
  "help.files.title": "📎 קבצים וייצוא",
  "help.files.point1": "צרף תמונות, סרטונים ומסמכי PDF.",
  "help.files.point2": "צלם תמונות עם מצלמה קדמית, מצלמה אחורית או מצלמת אינטרנט.",
  "help.files.point3": "התמונות נדחסות אוטומטית.",
  "help.files.point4": "תצוגה מקדימה לפני השליחה.",
  "help.files.point5": "סרגל התקדמות במהלך הטעינה.",
  "help.files.point6": "ייצא שיחות שלמות ל:",
  "help.files.point7": "PDF",
  "help.files.point8": "HTML",
  "help.files.point9": "כולל הודעות, תמונות וקבצים.",
  "help.files.point10": "הנתונים שלך הם שלך.",
  "help.experience.title": "🎨 חווית משתמש",
  "help.experience.point1": "סטטוסי נוכחות וסטטוסים מותאמים אישית עם אמוג'י.",
  "help.experience.point2": "אימוג'י משולבים של OpenMoji.",
  "help.experience.point3": "קריאה וכתיבה של אינדיקטורים.",
  "help.experience.point4": "תצוגה אופטימלית לנייד שווה לשולחן העבודה.",
  "help.experience.point5": "אפליקציית PWA ניתנת להתקנה.",
  "help.experience.point6": "שני נושאים: ארגנטינה (תכלת/לבן/זהב) ואוסקורו (סגול עמוק).",
  "help.experience.point7": "עריכת פרופיל ללא משקאות קלים.",
  "help.experience.point8": "בורר מדינה עם אזור זמן אוטומטי.",
  "help.experience.point9": "גישה מהירה עם מועדפים, חיפוש ומסננים.",
  "help.languages.point3": "ממשק, T&C ומיילים מותאמים לשפה הנבחרת.",
  "help.languages.point4": "תרגום אוטומטי דו-כיווני בין משתמשים.",
  "help.tipsNew.title": "💡 טיפים לנצל את היתרונות של ArChat®",
  "help.tipsNew.point1": "הזמן רק אנשים שאתה באמת רוצה לתקשר איתם.",
  "help.tipsNew.point2": "השתמש בכינויים והערות פרטיות כדי לארגן אנשי קשר.",
  "help.tipsNew.point3": "סמן מועדפים לגישה מהירה.",
  "help.tipsNew.point4": "בדוק את התרגום לפני שליחת הודעות חשובות.",
  "help.tipsNew.point5": "ייצא שיחות רלוונטיות לגיבוי או עבודה.",
  "help.tipsNew.point6": "השתמש ב-ArChat® כאשר הבהירות הכתובה היא המפתח.",
  "help.whySubscribe.title": "🚀 למה להירשם ל-ArChat®",
  "help.whySubscribe.point1": "ArChat® אינו מיועד לצ'אט עם כל אחד,",
  "help.whySubscribe.point2": "אלא לתקשר טוב יותר עם מי שחשוב.",
  "help.whySubscribe.point3": "אם אתה צריך:",
  "help.whySubscribe.point4": "בהירות בין השפות",
  "help.whySubscribe.point5": "פרטיות אמיתית",
  "help.whySubscribe.point6": "בקרת קשר",
  "help.whySubscribe.point7": "ייצוא שיחה",
  "help.whySubscribe.point8": "חוויה מקצועית ונטולת רעש",
  "help.whySubscribe.point9": "ArChat® מיועד לכך.",
  "help.how.step1.description": "השתמש בכינוי ובסיסמה שלך כדי לגשת. אם אין לך חשבון, הוא נוצר באופן אוטומטי.",
  "help.how.step2.title": "הזמן את איש הקשר שלך",
  "help.how.step2.description": "הזמן במייל מהפרופיל שלך והגדר את השפה ואופן השיחה.",
  "help.how.step3.title": "כתוב בשפה שלך",
  "help.how.step3.description": "כתוב בשפה המועדפת עליך ו-ArChat® יתרגם את ההודעה באופן אוטומטי.",
  "help.how.step4.title": "המקלט מקבל את זה מתורגם",
  "help.how.step4.description": "האדם האחר מקבל את המסר מתורגם לשפתו בהקשר ובבהירות.",
  "help.features.title": "תכונות עיקריות",
  "help.features.translation": "🌐 תרגום אוטומטי ומיידי בין שפות",
  "help.features.status": "💬 מצבי נוכחות (מקוון, סרק, נא לא להפריע וכו')",
  "help.features.statusCustom": "💬 סטטוסים מותאמים אישית עם אימוג'י והודעה מותאמת אישית",
  "help.features.contacts": "👥 רשימה מלאה של אנשי קשר עם מועדפים מוצמדים (למעלה) ובלוקים הניתנים לניהול ממודאל המשתמשים",
  "help.features.contactsMobile": "📱 תצוגה אופטימלית לנייד עם סטטוס ומראה בסרגל העליון (זהה למחשב האישי)",
  "help.features.contactsFilter": "👁️ כפתור הצג/הסתר אנשי קשר שאינם מועדפים - צמצם את הרשימה למועדפים בלבד",
  "help.features.contactAlias": "✏️ כינוי מותאם אישית והערות פרטיות לכל איש קשר - לחץ על שם איש הקשר בשיחה",
  "help.features.themes": "🎨 שני נושאים זמינים: ארגנטינה (תכלת/לבן/זהב) ואוסקורו (סגול עמוק)",
  "help.features.messages": "📨 העברת הודעות בזמן אמת עם מחווני קריאה, אימוג'י OpenMoji מוטבעים והקלדה גלויה",
  "help.features.attachments": "📎 צרף קבצים התואמים לתקשורת כתובה: תמונות, סרטונים ומסמכי PDF",
  "help.features.camera": "📸 צלם תמונות עם חזית, אחורי או מצלמת אינטרנט",
  "help.features.gallery": "🖼️ בחירת קבצים מהגלריה",
  "help.features.compression": "🗜️ דחיסת תמונה אוטומטית ויצירת תמונות ממוזערות",
  "help.features.progress": "📊 סרגל התקדמות במהלך העלאת קבצים",
  "help.features.delete": "🗑️ מחיקת הודעות משלך",
  "help.features.scroll": "⬇️ גלילה אוטומטית להודעה האחרונה בעת פתיחת שיחה",
  "help.features.profile": "👤 פרופיל ניתן להתאמה אישית עם אווטאר, ביוגרפיה והעדפות",
  "help.features.profileEdit": "✏️ עריכת פרופיל חלקה (לא מתרעננת בזמן העריכה)",
  "help.features.countries": "🌍 רשימה מלאה של 195+ מדינות עם בחירת אזור זמן אוטומטית",
  "help.features.registration": "📧 הרשמה עם תנאים והגבלות חובה לפני יצירת חשבון ואישור בדוא\"ל",
  "help.features.multilanguage": "🗣️ תמיכה ב-{count} שפות עם דגלים; תנאים והגבלות ואימיילים מתורגמים לשפה הנבחרת",
  "help.features.pwa": "📲 אפליקציית PWA ניתנת להתקנה במכשירים ניידים ובשולחן העבודה",
  "help.features.sync": "🔄 סנכרון הודעות אוטומטי כל 5 שניות",
  "help.features.deleteSync": "🗑️ סנכרון אוטומטי של הודעות שנמחקו בין מכשירים",
  "help.features.notifications": "🔔 התראות קול עבור הודעות חדשות שהתקבלו",
  "help.features.retranslation": "🔄 תרגום אוטומטי מחדש של הודעות אם הוא נכשל בפעם הראשונה",
  "help.features.preview": "👁️ תצוגה מקדימה של קבצים לפני השליחה",
  "help.features.security": "🔒 מערכת אבטחה עם CAPTCHA, טביעת אצבע, הגבלת קצב וזרימת T&C חובה",
  "help.features.passwordRecovery": "🔑 שחזור סיסמה בדוא\"ל",
  "help.features.emailConfirmation": "📧 אישור חשבון באימייל עם קישור הפעלה",
  "help.features.invitations": "📧 הזמנות דוא\"ל פרטיות - הזמן אנשי קשר חיצוניים עם שפה והקשר מוגדרים",
  "help.features.invitationsManagement": "📋 ניהול הזמנות מלא - רשום, שלח שוב או בטל הזמנות ממתינות מהתפריט",
  "help.features.contactStatus": "🏷️ סטטוסים של אנשי קשר גלויים - ראה את הסטטוס של כל איש קשר (בהמתנה, רשום, מוכן לצ'אט)",
  "help.features.favorites": "⭐ מערכת מועדפים - סמן אנשי קשר כמועדפים לגישה מהירה אליהם",
  "help.features.profilePhoto": "📸 העלאת תמונת פרופיל משופרת - בחר תמונות מהגלריה עם תצוגה מקדימה מיידית",
  "help.features.translationSender": "👁️ הצג תרגומים עבור השולח - ראה כיצד ההודעה שלך תורגמה לשפת הנמען",
  "help.features.unifiedContacts": "🔗 מודל קשר מאוחד - אנשי הקשר נגזרים מהזמנות ושיחות קיימות",
  "help.features.privacy": "🔒 מצב פרטי כברירת מחדל - הפרופיל שלך פרטי ונגיש רק בהזמנה ישירה",
  "help.features.export": "💾 ייצוא שיחה - ייצא שיחות שלמות ל-PDF או HTML עם תמונות וקבצים",
  "help.tips.title": "עצות מועילות",
  "help.tips.language": "✅ הגדר את השפה שלך עם בורר הדגלים {count}; תנאים ותנאים ואימיילים מוצגים בשפה זו",
  "help.tips.status": "✅ עדכן את סטטוס הנוכחות שלך כדי שאחרים ידעו את הזמינות שלך",
  "help.tips.statusCustom": "✅ צור סטטוסים מותאמים אישית עם אימוג'י והודעה כדי לבטא את הסטטוס הנוכחי שלך",
  "help.tips.search": "✅ סמן מועדפים (כוכב) וחסום משתמשים ממודאל \"משתמשים\".",
  "help.tips.contactsFilter": "✅ השתמש בלחצן העין (👁️) בסרגל העליון כדי להציג או להסתיר אנשי קשר שאינם מועדפים",
  "help.tips.contactAlias": "✅ לחץ על שם איש הקשר בשיחה כדי להוסיף כינוי מותאם אישית והערות פרטיות",
  "help.tips.avatar": "✅ לחץ על הדמות של איש קשר כדי לראות את התמונה שלו גדולה יותר",
  "help.tips.messages": "✅ סמל ArChat® מהבהב כאשר יש לך הודעות שלא נקראו; הכנס אימוג'י עם משגר OpenMoji",
  "help.tips.attachments": "✅ צרף תמונות, סרטונים או קובצי PDF באמצעות כפתור הקליפ (📎); תואם לתקשורת בכתב",
  "help.tips.camera": "✅ השתמש במצלמה כדי לצלם תמונות ישירות מהאפליקציה",
  "help.tips.compression": "✅ תמונות נדחסות אוטומטית כדי לחסוך במקום",
  "help.tips.delete": "✅ אתה יכול למחוק הודעות משלך על ידי לחיצה על כפתור המחיקה",
  "help.tips.profile": "✅ ערוך את הפרופיל שלך ללא סודה ועבור בין ארגנטינה לכהה (נושא בהיר או כהה).",
  "help.tips.themes": "✅ שנה את הנושא מהגדרות > מראה: ארגנטינה (תכלת) או כהה (סגול עמוק)",
  "help.tips.country": "✅ בחר את המדינה שלך בפרופיל כך שאזור הזמן יוגדר אוטומטית",
  "help.message_time_context.title": "הקשר זמני של הודעות",
  "help.message_time_context.description": "כל הודעה יכולה לשמור את הזמן המקומי, אזור הזמן והמדינה של השולח בזמן השליחה. כך תוכלו לראות לאן ובאיזה שעה המשתמש השני שלח.",
  "help.message_time_context.point1": "בתוכנית החינמית, רק השעה באזור הזמן שלך (מקלט) מוצגת.",
  "help.message_time_context.point2": "בתוכנית PRO, הזמן המקומי, המדינה ואזור הזמן של המנפיק מוצגים גם.",
  "help.message_time_context.point3": "ההקשר נשמר באופן היסטורי בכל הודעה.",
  "help.message_time_context.point4": "תכונות ביקורת מתקדמות זמינות בתוכניות גבוהות יותר.",
  "help.tips.registration": "✅ לפני ההרשמה, קבל את התנאים וההגבלות בשפתך; לאחר מכן אמת את האימייל שלך כדי להפעיל את החשבון",
  "help.tips.writing": "✅ כתוב מסרים ברורים: ArChat® מתרגם את המשמעות של טקסט כתוב, שומר על הקשר ובהירות",
  "help.tips.install": "✅ התקן את ArChat® כאפליקציית PWA במכשיר שלך לגישה מהירה לשולחן העבודה",
  "help.tips.sync": "✅ הודעות מסתנכרנות אוטומטית כל 5 שניות - אין צורך לרענן",
  "help.tips.deleteSync": "✅ אם תמחק הודעה, היא תימחק אוטומטית בכל מכשירי הנמען",
  "help.tips.notifications": "✅ תשמע צליל כשתקבל הודעה חדשה ממשתמש אחר",
  "help.tips.retranslation": "✅ אם הודעה לא תורגמה כהלכה, המערכת תנסה לתרגמה מחדש באופן אוטומטי",
  "help.tips.preview": "✅ בדוק את התצוגה המקדימה של הקובץ לפני השליחה כדי לוודא שהוא הנכון",
  "help.tips.passwordRecovery": "✅ אם שכחת את הסיסמה שלך, השתמש בקישור \"שכחת את הסיסמה שלך?\" בכניסה",
  "help.tips.emailConfirmation": "✅ בדוק את האימייל שלך לאחר ההרשמה ולחץ על קישור האישור",
  "help.tips.languageChange": "✅ שנה את השפה שלך מבורר הדגלים: תנאים ותנאים, אימיילים וממשק המשתמש מתעדכנים באופן מיידי",
  "help.tips.inputFixed": "✅ במחשב, פס הכתיבה קבוע בתחתית המסך לנוחות רבה יותר",
  "help.tips.invitations": "✅ הזמן אנשי קשר בדוא\"ל מהפרופיל שלך - הגדר את השפה ומצב השיחה מההתחלה",
  "help.tips.invitationsManagement": "✅ נהל את ההזמנות שלך מתפריט \"נשלחו הזמנות\" - שלח שוב מיילים או בטל הזמנות ממתינות",
  "help.tips.contactStatus": "✅ ראה את הסטטוס של כל איש קשר ברשימה - בהמתנה (כתום), רשום (ירוק) או שיחה פעילה (כחול)",
  "help.tips.favorites": "✅ סמן אנשי קשר כמועדפים עם הכוכב ⭐ - המועדפים מופיעים ראשונים ברשימה שלך",
  "help.tips.profilePhoto": "✅ העלה את תמונת הפרופיל שלך מ\"בחר מהגלריה\" - תראה תצוגה מקדימה לפני השמירה",
  "help.tips.translationSender": "✅ בעת שליחת הודעה, הרחב את לוח התרגום כדי לראות כיצד היא תורגמה לשפת הנמען",
  "help.tips.unifiedContacts": "✅ אנשי הקשר שלך מוצגים באופן אוטומטי כאשר הם מקבלים הזמנות או מנהלים איתם שיחות",
  "help.tips.privacy": "✅ הפרופיל שלך פרטי כברירת מחדל - הפעל את החשיפה הציבורית בפרופיל > פרטיות אם אתה רוצה שאחרים ימצאו אותך",
  "help.tips.export": "✅ ייצוא שיחות שלמות באמצעות כפתור ⬇️ בכותרת - בחר PDF או HTML עם כל התמונות",
  "help.support.title": "בֵּינוֹנִי",
  "help.support.description": "אם יש לך בעיות או שאלות, פנה למנהל המערכת שלך או עיין בתיעוד הטכני הזמין.",
  "help.about.title": "אוֹדוֹת",
  "help.about.developer": "פותח על ידי:",
  "help.about.location": "MDQ - ארגנטינה",
  "help.about.linkedin": "צפה בפרופיל בלינקדאין",
  "presence.custom.suggestion.coffee": "יש כמה בני זוג ☕",
  "presence.custom.suggestion.soccer": "על המגרש ⚽",
  "presence.custom.suggestion.working": "עובד כמו מטורף 💪",
  "presence.custom.suggestion.lunch": "אוכלים ארוחת צהריים 🍽️",
  "presence.custom.suggestion.family": "ארוחת צהריים משפחתית 👨‍👩‍👧‍👦",
  "presence.custom.suggestion.studying": "לומד 📚",
  "presence.custom.suggestion.travel": "בטיול ✈️",
  "presence.custom.suggestion.meeting": "בפגישה 💼",
  "presence.custom.suggestion.resting": "נח 😴",
  "presence.custom.suggestion.gaming": "משחק במשחקי וידאו 🎮",
  "presence.custom.suggestion.reading": "קריאה 📖",
  "presence.custom.suggestion.offlineSoon": "מיד אחזור ⏳",
  "export.title": "ייצוא שיחה",
  "export.description": "בחר את הפורמט שבו ברצונך לייצא את השיחה הזו:",
  "export.progress": "מייצא...",
  "export.format.pdf": "PDF",
  "export.format.pdf.description": "מסמך PDF עם כל התמונות והקבצים",
  "export.format.html": "HTML",
  "export.format.html.description": "קובץ HTML שניתן לפתוח בכל דפדפן",
  "export.info": "הייצוא יכלול את כל ההודעות, התמונות והקבצים משיחה זו.",
  "export.pro_required.title": "ייצוא שיחה",
  "export.pro_required.message": "תכונה זו זמינה בתוכנית PRO.",
  'invitation.top.title': 'בוני הרשת המובילים',
  'invitation.top.invitesSuffix': 'הזמנות',
  "invitation.safe.phase_notice": "שלב בטוח פעיל: הטבות בהמתנה להפעלה מסחרית (ללא השפעה ממשית על המגבלות).",
  "invitation.safe.generate_code": "צור קישור/קוד",
  "invitation.safe.refresh_top3": "עדכן את טופ 3",
  "invitation.safe.top_loading": "טוען מזמינים מובילים...",
  "invitation.safe.top_empty": "עדיין אין מוזמנים מומלצים.",
  "invitation.safe.hide_full_ranking": "הסתר דירוג מלא",
  "invitation.safe.view_full_ranking": "ראה דירוג מלא",
  "invitation.safe.hide_metrics_dashboard": "הסתר את לוח המחוונים של מדדים",
  "invitation.safe.view_metrics_dashboard": "הצג את לוח המחוונים של מדדים",
  "invitation.safe.prepared_link": "הקישור הוכן",
  "invitation.safe.email_placeholder": "email@dominio.com",
  "invitation.safe.register_pending": "הרשמה ממתינה להזמנה",
  "invitation.safe.status_summary": "סיכום סטטוס",
  "invitation.safe.summary.pending": "עגילים",
  "invitation.safe.summary.registered": "רָשׁוּם",
  "invitation.safe.summary.active": "פָּעִיל",
  "invitation.safe.summary.validated": "מאומת",
  "invitation.safe.summary.rejected": "נִדחֶה",
  "invitation.safe.sent_invitations": "הוצאו הזמנות",
  "invitation.safe.table.id": "תְעוּדַת זֶהוּת",
  "invitation.safe.table.invited_email": "אימייל לאורח",
  "invitation.safe.table.code": "קוד",
  "invitation.safe.table.status": "מְדִינָה",
  "invitation.safe.table.created": "נוצר",
  "invitation.safe.empty_sent": "עדיין לא יצאו הזמנות.",
  "invitation.safe.simulated_rewards": "פרסים מדומים שנצברו",
  "invitation.safe.empty_rewards": "אין תגמולים מדומים לעת עתה.",
  "invitation.safe.error.load_status": "לא ניתן לטעון את סטטוס ההזמנה.",
  "invitation.safe.error.generate_code": "לא ניתן היה ליצור את הקוד.",
  "invitation.safe.error.invalid_email": "הזן אימייל חוקי לרישום הזמנה.",
  "invitation.safe.error.register_pending": "לא ניתן היה לרשום את ההזמנה הממתינה.",
  "invitation.safe.success.code_generated": "קוד נוצר בהצלחה.",
  "invitation.safe.success.pending_registered": "הזמנה ממתינה רשומה במצב בטוח.",
  "invitation.ranking.position": "מַצָב",
  "invitation.ranking.user": "מִשׁתַמֵשׁ",
  "invitation.ranking.validatedInvites": "הזמנות מאומתות",
  "invitation.ranking.empty": "אין הזמנות מאומתות להצגה.",
  "invitation.ranking.loading": "טוען דירוג...",
  "invitation.ranking.loadError": "לא ניתן היה לטעון את הדירוג.",
  "invitation.copy.link": "העתק קישור",
  "invitation.copy.success": "הקישור הועתק ללוח",
  "invitation.accept.title": "קבל הזמנה",
  "invitation.accept.description": "הוזמנת לשוחח בצ'אט ב-ArChat®",
  "invitation.accept.inviter": "מוזמן על ידי",
  "invitation.accept.message": "הודעה אישית",
  "invitation.accept.login": "כְּנִיסָה לַמַעֲרֶכֶת",
  "invitation.accept.register": "לִרְשׁוֹם",
  "invitation.accept.error.invalid": "אסימון הזמנה לא חוקי",
  "invitation.accept.error.expired": "פג תוקף ההזמנה הזו",
  "invitation.accept.error.accepted": "הזמנה זו כבר התקבלה",
  "invitation.accept.error.cancelled": "הזמנה זו בוטלה",
  "invitation.accept.error.email_mismatch": "כתובת הדוא\"ל של החשבון שלך אינה תואמת למייל ההזמנה",
  "invitation.accept.success": "ההזמנה התקבלה. מפנה מחדש לצ'אט...",
  "invitations.sent.empty": "אין הזמנות ממתינות",
  "invitations.columns.email": "אֶלֶקטרוֹנִי",
  "invitations.columns.language": "שָׂפָה",
  "invitations.columns.status": "מְדִינָה",
  "invitations.columns.sentAt": "נשלח",
  "invitations.columns.actions": "פעולות",
  "invitations.status.pending": "עָגִיל",
  "invitations.status.accepted": "מְקוּבָּל",
  "invitations.status.cancelled": "בּוּטלָה",
  "invitations.status.expired": "פג תוקף",
  "invitations.actions.copy": "העתק קישור",
  "invitations.waitBeforeResend": "אתה עדיין לא יכול לשלוח שוב את ההזמנה. עליך להמתין 10 דקות בין כל שליחה כדי למנוע ספאם למשתמש האורח.",
  "invitations.captchaQuestion": "כמה זה %1 +%2?",
  "invitations.resendSuccess": "ההזמנה הועברה בהצלחה.",
  "invitations.dailyLimit": "הגעת למקסימום ההגשות החוזרות המותרות היום.",
  "invitations.invalidEmail": "שרת הדואר דיווח שכתובת זו אינה חוקית.",
  "profile.privacy.title": "פְּרָטִיוּת",
  "profile.privacy.public_visibility": "הפוך את הפרופיל שלי לגלוי לציבור",
  "profile.privacy.public_warning": "זה מאפשר לכל משתמש ArChat® למצוא אותך ולהתחיל שיחה.",
  "profile.privacy.private_info": "הפרופיל שלך פרטי. רק משתמשים שאתה מזמין או שמזמינים אותך יוכלו לשוחח איתך בצ'אט.",
  "profile.privacy.private_default": "כברירת מחדל, הפרופיל שלך פרטי לאבטחה מוגברת.",
  "common.save": "לִשְׁמוֹר",
  "common.saving": "חִסָכוֹן...",
  'buttons.accept': 'אישור',
  "buttons.cancel": "לְבַטֵל",
  "buttons.save": "לִשְׁמוֹר",
  "buttons.edit": "לַעֲרוֹך",
  "buttons.retry": "נסה שוב",
  "buttons.confirm": "לְאַשֵׁר",
  "buttons.yes": "כֵּן",
  "buttons.no": "לֹא",
  "buttons.send": "לִשְׁלוֹחַ",
  "buttons.close": "לִסְגוֹר",
  "buttons.continue": "לְהַמשִׁיך",
  "buttons.delete": "לְחַסֵל",
  "buttons.logout": "לָצֵאת",
  "buttons.back": "לַחֲזוֹר",
  "buttons.update": "לְעַדְכֵּן",
  "buttons.upload": "לְהַגדִיל",
  "buttons.select": "לִבחוֹר",
  "achievement.unlocked": "ההישג נפתח",
  "achievement.continue": "לְהַמשִׁיך",
  "contact.edit.info.personalized": "שינויים אלה מותאמים אישית רק עבורך ואינם משפיעים על משתמשים אחרים.",
  "contact.edit.profileInfo": "מידע על פרופיל",
  "dashboard.loading": "טוען נתונים...",
  "dashboard.error.title": "טָעוּת",
  "dashboard.error.load": "לא ניתן היה לטעון נתוני שימוש",
  "dashboard.error.generic": "שגיאה בטעינת לוח המחוונים",
  "dashboard.error.no_data": "לא ניתן היה לטעון נתונים",
  "dashboard.retry": "נסה שוב",
  "dashboard.unlimited": "בִּלתִי מוּגבָּל",
  'dashboard.not_available': 'לא זמין',
  "dashboard.plan.free": "FREE",
  "dashboard.plan.pro": "PRO",
  "dashboard.plan.enterprise": "ENTERPRISE",
  "dashboard.card.chars": "דמויות",
  "dashboard.card.chars_month": "דמויות החודש",
  "dashboard.card.storage": "אִחסוּן",
  "dashboard.card.devices": "מכשירים פעילים",
  "dashboard.admin.title": "מדדי צמיחה",
  "dashboard.admin.newUsersToday": "משתמשים חדשים היום",
  "dashboard.admin.messagesSentToday": "הודעות שנשלחו היום",
  "dashboard.admin.translationsUsed": "נעשה שימוש בתרגומים",
  "dashboard.admin.invitesCreated": "נוצרו הזמנות",
  "dashboard.admin.invitesValidated": "הזמנות מאומתות",
  "dashboard.admin.inviteConversion": "המרת הזמנה",
  "dashboard.admin.kFactor": "K-Factor",
  "dashboard.admin.newUsers": "משתמשים חדשים",
  "dashboard.admin.messagesSent": "נשלחו הודעות",
  "dashboard.admin.noData": "אין נתונים",
  "dashboard.admin.kFactor.viral": "נְגִיפִי",
  "dashboard.admin.kFactor.stable": "יַצִיב",
  "dashboard.admin.kFactor.low": "נָמוּך",
  "dashboard.admin.emailMetrics": "מדדי אימייל",
  "dashboard.admin.email.sent": "נשלח",
  "dashboard.admin.email.delivered": "נמסר",
  "dashboard.admin.email.opened": "לִפְתוֹחַ",
  "dashboard.admin.email.clicked": "קליקים",
  "dashboard.admin.email.bounced": "הוקפץ",
  "dashboard.admin.email.deliveryRate": "שיעור משלוח",
  "dashboard.admin.email.openRate": "שער פתוח",
  "dashboard.admin.email.bounceRate": "שיעור יציאה מדף הכניסה",
  "dashboard.admin.funnelMetrics": "מדדי משפך",
  "dashboard.admin.funnel.registered": "רָשׁוּם",
  "dashboard.admin.funnel.confirmed": "מְאוּשָׁר",
  "dashboard.admin.funnel.loggedIn": "כניסה ראשונה",
  "dashboard.admin.funnel.firstMessage": "הודעה ראשונה",
  "dashboard.admin.funnel.abandoned": "נָטוּשׁ",
  "dashboard.admin.funnel.conversionRate": "שיעור המרה",
  "dashboard.admin.funnel.activationRate": "קצב הפעלה",
  "dashboard.admin.funnel.dropoffRate": "שיעור נשירה",
  "dashboard.admin.loading": "טוען מדדים...",
  "dashboard.admin.errorLoad": "לא ניתן היה לטעון את לוח המחוונים של המדדים.",
  "dashboard.admin.growthViral": "צמיחה ויראלית",
  "dashboard.admin.growthStable": "צמיחה יציבה",
  "dashboard.admin.growthLow": "צמיחה נמוכה",
  "dashboard.upgrade.title": "האם אתה צריך עוד משאבים?",
  'dashboard.upgrade.message': 'Upgrade your plan to get more contacts, characters, storage and active devices.',
  "dashboard.upgrade.button": "שפר את התוכנית",
  "upgrade.title": "שפר את התוכנית",
  "upgrade.close": "לִסְגוֹר",
  "upgrade.cancel": "לְבַטֵל",
  "upgrade.activate": "הפעל את תוכנית PRO",
  "upgrade.activating": "מפעיל...",
  'upgrade.price.amount': '',
  'upgrade.price.period': '',
  'upgrade.price.note': '',
  "upgrade.comparison.title": "השוואת תוכניות",
  "upgrade.free.label": "תוכנית חינם",
  "upgrade.free.limits.contacts": "מקסימום 2 אנשי קשר",
  "upgrade.free.limits.conversations": "מקסימום 2 שיחות",
  "upgrade.free.limits.no_export": "אין ייצוא נתונים",
  "upgrade.free.limits.no_advanced": "אין תכונות מתקדמות",
  "upgrade.pro.label": "תוכנית פרו",
  "upgrade.pro.recommended": "מוּמלָץ",
  'upgrade.pro.benefits.contacts': 'Unlimited contacts',
  'upgrade.pro.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.pro.benefits.conversations': 'Unlimited conversations',
  'upgrade.pro.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.pro.benefits.export": "ייצוא שיחה",
  "upgrade.pro.benefits.export.desc": "ייצא את השיחות שלך במספר פורמטים (PDF, TXT, JSON)",
  "upgrade.pro.benefits.notifications": "התראות מתקדמות",
  "upgrade.pro.benefits.notifications.desc": "התראות מותאמות אישית והגדרות מתקדמות",
  'upgrade.pro.benefits.translation': 'Unlimited automatic translation',
  'upgrade.pro.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.pro.benefits.files': 'Unlimited file sharing',
  'upgrade.pro.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.pro.benefits.themes": "ערכות נושא מותאמות אישית",
  "upgrade.pro.benefits.themes.desc": "גישה לכל הנושאים והתאמה אישית מתקדמת",
  "upgrade.pro.benefits.security": "אבטחה מתקדמת",
  "upgrade.pro.benefits.security.desc": "הגנה נוספת ותכונות פרטיות משופרות",
  "upgrade.pro.benefits.analytics": "סטטיסטיקה וניתוח",
  "upgrade.pro.benefits.analytics.desc": "גישה לסטטיסטיקה מפורטת של הפעילות שלך",
  "upgrade.pro.benefits.priority": "תמיכה בעדיפות",
  "upgrade.pro.benefits.priority.desc": "תשומת לב עדיפות ומענה מהיר לשאלותיך",
  "upgrade.enterprise.label": "תוכנית ארגונית",
  "upgrade.enterprise.title": "ENTERPRISE",
  "upgrade.enterprise.benefits.contacts": "אנשי קשר ללא הגבלה",
  "upgrade.enterprise.benefits.support": "תמיכה בעדיפות 24/7",
  "upgrade.enterprise.benefits.custom": "פתרונות מותאמים אישית",
  "upgrade.enterprise.benefits.advanced": "תכונות עסקיות מתקדמות",
  "upgrade.enterprise.benefits.integration": "אינטגרציות מותאמות אישית",
  "upgrade.enterprise.benefits.dedicated": "תמיכה ייעודית",
  "upgrade.success.title": "תוכנית PRO הופעלה",
  "upgrade.success.message": "התוכנית שלך שודרגה ל-PRO. תהנה מכל התכונות הבלתי מוגבלות.",
  "upgrade.error.title": "שגיאה בהפעלת PRO",
  "upgrade.error.message": "לא ניתן היה לעדכן את התוכנית. אנא נסה שוב.",
  "upgrade.error.generic": "אירעה שגיאה בלתי צפויה. אנא נסה שוב.",
  'upgrade.benefits.contacts': 'Unlimited contacts',
  'upgrade.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.benefits.conversations': 'Unlimited conversations',
  'upgrade.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.benefits.export": "ייצוא שיחה",
  "upgrade.benefits.export.desc": "ייצא את השיחות שלך במספר פורמטים (PDF, TXT, JSON)",
  "upgrade.benefits.notifications": "התראות מתקדמות",
  "upgrade.benefits.notifications.desc": "התראות מותאמות אישית והגדרות מתקדמות",
  'upgrade.benefits.translation': 'Unlimited automatic translation',
  'upgrade.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.benefits.files': 'Unlimited file sharing',
  'upgrade.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.benefits.themes": "ערכות נושא מותאמות אישית",
  "upgrade.benefits.themes.desc": "גישה לכל הנושאים והתאמה אישית מתקדמת",
  "upgrade.benefits.security": "אבטחה מתקדמת",
  "upgrade.benefits.security.desc": "הגנה נוספת ותכונות פרטיות משופרות",
  "upgrade.benefits.analytics": "סטטיסטיקה וניתוח",
  "upgrade.benefits.analytics.desc": "גישה לסטטיסטיקה מפורטת של הפעילות שלך",
  "upgrade.benefits.priority": "תמיכה בעדיפות",
  "upgrade.benefits.priority.desc": "תשומת לב עדיפות ומענה מהיר לשאלותיך",
  "upgrade.limits.contacts": "מקסימום 2 אנשי קשר",
  "upgrade.limits.conversations": "מקסימום 2 שיחות",
  "upgrade.limits.no_export": "אין ייצוא נתונים",
  "upgrade.limits.no_advanced": "אין תכונות מתקדמות",
  "api.error.image_processing_not_available": "עיבוד תמונה אינו זמין בשרת",
  "api.error.image_functions_not_available": "פונקציות עיבוד תמונה אינן זמינות",
  "api.error.method_not_allowed": "שיטה אסורה",
  "api.error.user_not_identified": "משתמש לא מזוהה",
  "api.error.upload_file_too_large_php": "הקובץ חורג מהגודל המרבי המותר על ידי PHP",
  "api.error.upload_file_too_large_form": "הקובץ חורג מהגודל המרבי המותר בטופס",
  "api.error.upload_file_partial": "הקובץ הועלה חלקית",
  "api.error.upload_no_file": "לא הועלה קובץ",
  "api.error.upload_no_temp_dir": "ספרייה זמנית חסרה",
  "api.error.upload_cant_write": "שגיאה בכתיבת קובץ לדיסק",
  "api.error.upload_extension_stopped": "תוסף PHP הפסיק להעלות",
  "api.error.upload_generic": "שגיאה בהעלאת קובץ",
  "api.error.file_type_not_allowed": "סוג קובץ אינו מותר. רק תמונות (JPEG, PNG, GIF, WEBP) מותרות",
  "api.error.file_too_large": "הקובץ גדול מדי (מקסימום 10MB)",
  "api.error.storage_limit_exceeded": "חרגת ממגבלת האחסון. שדרג את התוכנית שלך כדי להעלות קבצים נוספים.",
  "api.error.user_not_found": "המשתמש לא נמצא או לא פעיל",
  "api.error.image_directory_access": "שגיאה בגישה לספריית התמונות",
  "api.error.file_extension_not_allowed": "סיומת קובץ אסורה",
  "api.error.temp_file_save": "שגיאה בשמירת קובץ זמני",
  "api.error.image_processing": "שגיאה בעיבוד התמונה",
  "api.error.database_update": "שגיאה בעדכון מסד הנתונים",
  "api.error.internal_server_error": "שגיאת שרת פנימית",
  "api.error.internal_server_error_debug": "שגיאת שרת פנימית",
  "api.error.user_id_required": "זיהוי משתמש נדרש",
  "api.error.profile_not_found": "הפרופיל לא נמצא",
  "api.error.profile_load_failed": "שגיאה בטעינת הפרופיל",
  "api.error.invalid_data": "נתונים לא חוקיים",
  "api.error.validation_errors": "שגיאות אימות",
  "api.error.profile_update_failed": "לא ניתן היה לעדכן את הפרופיל",
  "api.error.profile_update_error": "שגיאה בעדכון הפרופיל",
  "api.success.photo_updated": "תמונה מעודכנת",
  "api.success.profile_loaded": "הפרופיל נטען בהצלחה",
  "api.success.profile_updated": "הפרופיל עודכן בהצלחה",
  "errors.deviceLimit.title": "הגעת למגבלת המכשירים",
  "errors.deviceLimit.solution": "כדי להמשיך, צא ממכשירים אחרים או שדרג את התוכנית שלך.",
  "errors.network.title": "שגיאת חיבור",
  "errors.network.message": "לא ניתן להתחבר לשרת. בדוק את חיבור האינטרנט שלך.",
  "errors.server.invalidResponse.title": "שגיאת שרת",
  "errors.server.invalidResponse.message": "השרת החזיר תגובה לא חוקית. נסה שוב.",
  "errors.modal.title": "טָעוּת",
  "errors.modal.copyDetails": "העתק פירוט",
  "errors.modal.close": "לִסְגוֹר",
  "errors.modal.reportSupport": "דווח לתמיכה",
  "errors.modal.code": "קוד",
  "errors.modal.message": "הוֹדָעָה",
  "errors.modal.path": "מַסלוּל",
  "errors.modal.time": "שָׁעָה",
  "errors.modal.timestamp": "חותמת זמן",
  "errors.modal.copied": "פרט מועתק",
  "errors.generic.title": "טָעוּת",
  "errors.generic.message": "אירעה שגיאה. נסה שוב.",
  "errors.unexpected": "אירעה שגיאה בלתי צפויה. נסה שוב.",
  "errors.boundary.title": "שגיאת תגובה נתפסה",
  "errors.boundary.request_id": "X-Request-ID:",
  "errors.boundary.correlate": "מפה ל-backend/logs/structured.log",
  "errors.boundary.message_label": "הוֹדָעָה:",
  "errors.boundary.stack_trace": "עקבות מחסנית",
  "errors.boundary.component_stack": "מחסנית רכיבים",
  "errors.boundary.empty": "(רֵיק)",
  "errors.boundary.reload_page": "טען מחדש את הדף",
  "errors.ui_boundary.refresh": "שגיאת ממשק ArChat - טעינת עמוד מחדש",
  "bootstrap.error.title": "ArChat® - שגיאת אתחול",
  "common.reload": "טען מחדש",
  "errors.avatarTooLarge": "התמונה חורגת מהגודל המותר של 2MB.",
  "errors.avatarTooLarge.title": "תמונה גדולה מדי",
  "errors.avatarTooLarge.message": "התמונה חורגת מהגודל המותר של 2MB.",
  "errors.invalidImageType": "הקובץ שנבחר אינו תמונה חוקית.",
  "errors.invalidImageType.title": "קובץ לא חוקי",
  "errors.invalidImageType.message": "הקובץ שנבחר אינו תמונה חוקית.",
  "errors.uploadFailed": "לא ניתן להעלות תמונה. נסה שוב.",
  "errors.uploadFailed.title": "שגיאה בהעלאה",
  "errors.uploadFailed.message": "לא ניתן להעלות תמונה. נסה שוב.",
  "errors.conversationCreate": "שגיאה ביצירת שיחה. אנא נסה שוב.",
  "errors.conversationInvalidId": "מזהה שיחה לא חוקי.",
  "errors.conversationOpen": "שגיאה בפתיחת שיחה. אנא נסה שוב.",
  "errors.favoriteUpdate": "עדכון המועדף נכשל",
  "errors.blockUpdate": "לא ניתן היה לעדכן את הנעילה",
  "errors.messageEdit": "שגיאה בעריכת ההודעה.",
  "errors.generic.403.title": "שגיאת גישה",
  "errors.generic.403.message": "אין לך הרשאה לבצע פעולה זו.",
  "errors.saas_max_users": "הגעת למגבלת המשתמשים של התוכנית ({current}/{limit}).",
  "errors.tenant_frozen": "השוכר חסום זמנית.",
  "errors.auth_invalid_credentials": "שם משתמש או סיסמה שגויים.",
  "errors.foundation_sold_out": "מקומות המייסדים אזלו.",
  "errors.unexpected_error": "אירעה שגיאה בלתי צפויה. נסה שוב.",
  "errors.accountInactive.title": "החשבון אינו פעיל. השלם את האימייל שלך כדי להפעיל אותו מחדש.",
  "errors.userInactive.title": "חשבון מושבת",
  "errors.tenantMismatch.title": "טעות דייר",
  "errors.accountInactive.activate": "הפעל עכשיו",
  "errors.accountInactive.accept": "לְקַבֵּל",
  "errors.accountInactive.success": "החשבון הופעל מחדש. עכשיו אתה יכול להיכנס.",
  "errors.accountInactive.fail": "לא ניתן להפעיל מחדש את החשבון. נסה שוב.",
  "errors.accountInactive.completeSuccess": "החשבון הופעל עם האימייל שלך. עכשיו אתה יכול להיכנס.",
  "errors.accountInactive.completeFail": "לא ניתן היה להשלים את ההפעלה. בדוק את האימייל ונסה שוב.",
  "plan.errors.deviceLimit.title": "הגעת למגבלת התוכנית",
  "plan.errors.deviceLimit.message": "לתוכנית הנוכחית שלך יש מגבלה על מספר המכשירים המחוברים בו זמנית.",
  "plan.errors.deviceLimit.solution": "כדי להמשיך, צא ממכשירים אחרים או שדרג את התוכנית שלך ל-PRO.",
  "plan.errors.contactsLimit.title": "הגעת למגבלת אנשי הקשר",
  "plan.errors.contactsLimit.message": "לתוכנית הנוכחית שלך יש הגבלה על מספר אנשי הקשר שיכולים להיות לך.",
  "plan.errors.contactsLimit.solution": "כדי להוסיף עוד אנשי קשר, שדרג את התוכנית שלך ל-PRO.",
  "plan.errors.invitationsLimit.title": "הגעת למגבלת ההזמנות",
  "plan.errors.invitationsLimit.message": "לתוכנית הנוכחית שלך יש מגבלה על מספר ההזמנות שאתה יכול לשלוח ביום.",
  "plan.errors.invitationsLimit.solution": "כדי לשלוח הזמנות נוספות, שדרג את התוכנית שלך ל-PRO.",
  "plan.errors.messagesLimit.title": "הגעת למגבלת ההודעות",
  "plan.errors.messagesLimit.message": "לתוכנית הנוכחית שלך יש הגבלה על מספר ההודעות שאתה יכול לשלוח ביום.",
  "plan.errors.messagesLimit.solution": "כדי לשלוח הודעות נוספות, שדרג את התוכנית שלך ל-PRO.",
  "plan.errors.storageLimit.title": "הגעת למגבלת האחסון",
  "plan.errors.storageLimit.message": "לתוכנית הנוכחית שלך יש מגבלה על כמות האחסון הפנוי.",
  "plan.errors.storageLimit.solution": "לאחסון נוסף, שדרג ל-PRO.",
  "plan.errors.chatsLimit.title": "הגעת למגבלת השיחה",
  "plan.errors.chatsLimit.message": "לתוכנית הנוכחית שלך יש מגבלה על מספר השיחות שאתה יכול לנהל.",
  "plan.errors.chatsLimit.solution": "כדי ליצור שיחות נוספות, שדרג את התוכנית שלך ל-PRO.",
  "plan.errors.upgradeRequired.title": "נדרש שדרוג תוכנית",
  "plan.errors.upgradeRequired.message": "תכונה זו דורשת תוכנית גבוהה יותר מזו שיש לך כרגע.",
  "plan.errors.upgradeRequired.solution": "שדרג את התוכנית שלך ל-PRO כדי לגשת לתכונה זו.",
  "appearance.theme.system": "מַעֲרֶכֶת",
  "appearance.theme.corporate": "תאגידי",
  "theme.system": "מַעֲרֶכֶת",
  "theme.corporate": "תאגידי",
  "founder.modalClose": "לִסְגוֹר",
  "founder.activeCountLabel": "מייסדים פעילים",
  "founder.urgency.lastSlots": "מקומות פנויים למייסד אחרונים",
  "founder.positionLabel": "מייסד #{position} / {limit}",
  "founder.leaderboard.title": "המייסדים המובילים",
  'auth.tagline': 'כוחה של הבנה — בכל שפה',
  'auth.sign_in': 'כניסה',
  'auth.create_account': 'פתיחת חשבון',
  'ui.search_contact': 'חיפוש איש קשר...',
  'ui.language': 'שפה',
  "contacts.mode": "מצב",
  "contacts.sent": "נשלח",
  "contacts.actions": "פעולות",
  "contacts.pending": "עָגִיל",
  "contacts.invited_registered": "אורח - רשום",
  "table.email": "אֶלֶקטרוֹנִי",
  "table.language": "שָׂפָה",
  "table.mode": "מצב",
  "table.status": "מְדִינָה",
  "table.sent": "נשלח",
  "table.actions": "פעולות",
  "admin.access_denied.message": "הוֹדָעָה",
  "admin.access_denied.title": "כּוֹתֶרֶת",
  "admin.action.change_plan": "שנה תוכנית",
  "admin.action.reactivate": "הפעל מחדש",
  "admin.action.suspend": "לְהַשְׁעוֹת",
  "admin.action.view": "נוֹף",
  "admin.confirm.change_plan.message": "הוֹדָעָה",
  "admin.confirm.change_plan.title": "כּוֹתֶרֶת",
  "admin.confirm.suspend.message": "הוֹדָעָה",
  "admin.confirm.suspend.title": "כּוֹתֶרֶת",
  "admin.details.created": "נוצר",
  "admin.details.current_plan": "תוכנית נוכחית",
  "admin.details.domain": "תְחוּם",
  "admin.details.last_activity": "פעילות אחרונה",
  "admin.details.name": "בַּטָטָה",
  "admin.details.plan": "לְתַכְנֵן",
  "admin.details.status": "סטָטוּס",
  "admin.details.subscription": "מִנוּי",
  "admin.details.tenant_id": "זיהוי דייר",
  "admin.details.tenant_info": "מידע על דייר",
  "admin.details.usage": "נוֹהָג",
  "admin.error.change_plan": "שנה תוכנית",
  "admin.error.generic": "כְּלָלִי",
  "admin.error.load_details": "טען פרטים",
  "admin.error.load_tenants": "עומס דיירים",
  "admin.error.reactivate": "הפעל מחדש",
  "admin.error.suspend": "לְהַשְׁעוֹת",
  "admin.error.title": "כּוֹתֶרֶת",
  "admin.filter.active": "לְהַפְעִיל",
  "admin.filter.all_plans": "כל התוכניות",
  "admin.filter.all_status": "כל הסטטוס",
  "admin.filter.suspended": "לְהַשְׁעוֹת",
  "admin.limit.devices": "התקנים",
  "admin.limit.invitations": "הזמנות",
  "admin.limit.messages": "הודעות",
  "admin.limit.storage": "אִחסוּן",
  "admin.limit.users": "משתמשים",
  "admin.loading": "טְעִינָה",
  "admin.no_tenants": "לא דיירים",
  "admin.plan.enterprise": "Enterprise",
  "admin.plan.free": "Free",
  "admin.plan.pro": "Pro",
  "admin.status.active": "לְהַפְעִיל",
  "admin.status.suspended": "לְהַשְׁעוֹת",
  'admin.subscription.id': 'Id',
  "admin.subscription.last_payment": "תשלום אחרון",
  "admin.subscription.status": "סטָטוּס",
  "admin.subtitle": "כְּתוּבִית",
  "admin.success.plan_changed": "התוכנית השתנתה",
  "admin.success.tenant_reactivated": "השוכר הופעל מחדש",
  "admin.success.tenant_suspended": "דייר הושעה",
  "admin.success.title": "כּוֹתֶרֶת",
  "admin.table.actions": "פעולות",
  "admin.table.messages": "הודעות",
  "admin.table.name": "בַּטָטָה",
  "admin.table.plan": "לְתַכְנֵן",
  "admin.table.status": "סטָטוּס",
  "admin.table.storage": "אִחסוּן",
  "admin.table.tenant_id": "זיהוי דייר",
  "admin.table.users": "משתמשים",
  "admin.title": "כּוֹתֶרֶת",
  "admin.usage.devices": "התקנים",
  "admin.usage.invitations": "הזמנות",
  "admin.usage.messages": "הודעות",
  "admin.usage.storage": "אִחסוּן",
  "admin.usage.users": "משתמשים",
  "auth.login": "כְּנִיסָה לַמַעֲרֶכֶת",
  "auth.register": "לִרְשׁוֹם",
  "auth.reset_password": "לאפס סיסמה",
  "billing.cancel.button": "לַחְצָן",
  "billing.cancel.canceling": "מבטל",
  "billing.cancel.confirm": "לְאַשֵׁר",
  "billing.cancel.error": "טָעוּת",
  "billing.cancel.success": "הַצלָחָה",
  "billing.character_billing.characters_used": "משתמשים בדמויות",
  "billing.character_billing.consumption_pct": "צריכה pct",
  "billing.character_billing.days_remaining": "נותרו ימים",
  "billing.character_billing.deletion_date": "תאריך מחיקה",
  "billing.character_billing.period_start": "תחילת תקופה",
  "billing.character_billing.renewal_date": "תאריך חידוש",
  "billing.character_billing.title": "כּוֹתֶרֶת",
  "billing.current_plan": "תוכנית נוכחית",
  "billing.founder_badge": "תג מייסד",
  "billing.no_plans": "אל תתכנן",
  'billing.subscription.canceled': 'Canceled',
  'billing.subscription.canceled_note': 'Canceled note',
  "billing.subscription.next_payment": "התשלום הבא",
  "billing.subscription.plan": "לְתַכְנֵן",
  'billing.subscription.price': 'מחיר התוכנית',
  "billing.subscription.started": "התחיל",
  "billing.subscription.status": "סטָטוּס",
  "billing.subscription.mp_flow.subscribe_failed": "לא ניתן היה להתחיל את המנוי. נסה שוב.",
  "billing.subscription.mp_flow.change_plan_failed": "לא ניתן היה לשנות את התוכנית. נסה שוב.",
  "billing.subscription.mp_status.pending": "עָגִיל",
  "billing.subscription.mp_status.authorized": "מוּסמָך",
  "billing.subscription.mp_status.active": "פָּעִיל",
  "billing.subscription.mp_status.paused": "מושהה",
  "billing.subscription.mp_status.cancelled": "בּוּטלָה",
  "billing.subscription.mp_status.inactive": "לֹא פָּעִיל",
  "billing.subscription.mp_status.unknown": "זר",
  "billing.unlimited": "בִּלתִי מוּגבָּל",
  "billing.update_plan": "עדכון תוכנית",
  "billing.update_plan_modal.title": "כּוֹתֶרֶת",
  "billing.usage.loading": "טְעִינָה",
  "common.accept": "לְקַבֵּל",
  "common.confirmPassword": "ConfirmPassword",
  "common.error": "טָעוּת",
  "dashboard.upgrade.to_plan": "לתכנן",
  "emoji.noResults": "אין תוצאות",
  "emoji.pick": "לִבחוֹר",
  "export.restricted.message": "הוֹדָעָה",
  "export.restricted.title": "כּוֹתֶרֶת",
  "export.restricted.upgrade": "שדרוג",
  "founder.*": "*",
  "help.faq.a1": "A1",
  "help.faq.a2": "A2",
  "help.faq.a3": "A3",
  "help.faq.a4": "A4",
  "help.faq.a5": "A5",
  "help.faq.a6": "A6",
  "help.faq.a7": "A7",
  "help.faq.q1": "שאלה 1",
  "help.faq.q2": "שאלה 2",
  "help.faq.q3": "שאלה 3",
  "help.faq.q4": "שאלה 4",
  "help.faq.q5": "שאלה 5",
  "help.faq.q6": "שאלה 6",
  "help.faq.q7": "שאלה 7",
  "help.faq.title": "כּוֹתֶרֶת",
  "help.howWorks.step4.point7": "נקודה 7",
  "help.message_time_context.free_vs_pro": "חינם לעומת מקצוען",
  "help.message_time_context.point5": "נקודה 5",
  "help.plans.enterprise.benefits": "הטבות",
  "help.plans.enterprise.description": "תֵאוּר",
  "help.plans.enterprise.title": "כּוֹתֶרֶת",
  "help.plans.foundation.devices": "התקנים",
  "help.plans.free.description": "תֵאוּר",
  "help.plans.free.devices": "התקנים",
  "help.plans.free.limits": "גבולות",
  "help.plans.free.title": "כּוֹתֶרֶת",
  "help.plans.intro": "הקדמה",
  "help.plans.pro.benefits": "הטבות",
  "help.plans.pro.description": "תֵאוּר",
  "help.plans.pro.devices": "התקנים",
  'help.plans.pro.price': '$19 לחודש',
  "help.plans.pro.title": "כּוֹתֶרֶת",
  "help.plans.pro.upgrade": "שדרוג",
  "help.plans.title": "כּוֹתֶרֶת",
  "help.plans.urgent_slots_badge": "תג משבצות דחוף",
  "help.slogan.final": "סוֹף",
  "help.suggestions.point1": "נקודה 1",
  "help.suggestions.point2": "נקודה 2",
  "help.suggestions.title": "כּוֹתֶרֶת",
  "invitation.already_contact_added": "איש קשר כבר נוסף",
  "invitation.already_contact_title": "כותרת כבר ליצור קשר",
  "invitation.already_pending": "כבר בהמתנה",
  "invitation.language.invalid": "לֹא בְּתוֹקֶף",
  "message.send": "לִשְׁלוֹחַ",
  "message.sendFile": "SendFile",
  "messages.conversations": "שיחות",
  "messages.no_conversations_subtitle": "אין כתוביות לשיחות",
  "messages.no_conversations_title": "אין כותרת לשיחות",
  "presence.custom.edit": "לַעֲרוֹך",
  "profile.enrichment.country": "מְדִינָה",
  "profile.enrichment.country.select": "לִבחוֹר",
  "profile.enrichment.description": "תֵאוּר",
  "profile.enrichment.org_size": "גודל הארגון",
  "profile.enrichment.org_size.placeholder": "מחזיק מקום",
  "profile.enrichment.save": "לְהַצִיל",
  "profile.enrichment.skip": "לְדַלֵג",
  "profile.enrichment.title": "כּוֹתֶרֶת",
  "profile.enrichment.usage_type.label": "מַדבֵּקָה",
  "profile.enrichment.usage_type.placeholder": "מחזיק מקום",
  "profile.founderPosition": "מיקום מייסד",
  "settings.confirmations.description": "תֵאוּר",
  "settings.confirmations.disable": "השבת",
  "settings.confirmations.title": "כּוֹתֶרֶת",
  "settings.confirmations.updated": "מְעוּדכָּן",
  "settings.title": "כּוֹתֶרֶת",
  "theme.description": "תֵאוּר",
  "google.unavailable_tenant": "Google אינה זמינה עבור דייר זה.",
  "google.unavailable": "Google לא זמין.",
  "google.verify_client_id": "אמת את מזהה הלקוח ב-Google Cloud Console.",
  'google.login_aria': 'התחברות עם Google',
  "message.preview_alt": "תצוגה מקדימה",
  "message.image_attachment_alt": "תמונה מצורפת",
  "profile.avatar.alt": "גִלגוּל",
  "plan.name.free": "FREE",
  "plan.name.pro": "PRO",
  "plan.name.foundation": "FOUNDATION",
  "plan.name.enterprise": "ENTERPRISE",
  "register.emailPlaceholder": "you@email.com",
  "invitation.top.loading": "טוען מזמינים מובילים...",
  "invitation.top.empty": "עדיין אין מזמינים מומלצים.",
  "invitation.contacts.title": "הזמן אנשי קשר",
  "invitation.contacts.safe_phase_note": "שלב בטוח פעיל: הטבות ממתינות ללא השפעה על מגבלות אמיתיות.",
  "invitation.contacts.generate_code": "צור קוד/קישור",
  "invitation.contacts.refresh_top3": "רענן את הטופ 3",
  "invitation.contacts.hide_full_ranking": "הסתר דירוג מלא",
  "invitation.contacts.show_full_ranking": "הצג דירוג מלא",
  "invitation.contacts.hide_metrics_dashboard": "הסתר את לוח המחוונים של מדדים",
  "invitation.contacts.show_metrics_dashboard": "הצג את לוח המחוונים של מדדים",
  "invitation.contacts.prepared_link_label": "קישור מוכן:",
  "invitation.contacts.email_placeholder": "email@domain.com",
  "invitation.contacts.register_pending": "הרשמה ממתינה להזמנה",
  "invitation.contacts.status_summary": "סיכום מצב",
  "invitation.contacts.sent_invitations": "שלחו הזמנות",
  "invitation.contacts.invited_email": "אימייל מוזמן",
  "invitation.contacts.code": "קוד",
  "invitation.contacts.no_sent_invitations": "עדיין לא שלחתי הזמנות.",
  "invitation.contacts.simulated_rewards": "הושגו תגמולים מדומים",
  "invitation.contacts.no_simulated_rewards": "עדיין אין תגמולים מדומים.",
  "common.id": "תְעוּדַת זֶהוּת",
  "common.created": "נוצר",
  "plan.pro_contacts": "Hasta 100 contactos por usuario",
  "common.status": "סטָטוּס",
  'login.prompt_create_account_with_name': 'ליצור חשבון בשם הזה?',
  'auth.pending_activation.title': 'החשבון ממתין להפעלה',
  'auth.pending_activation.body': 'החשבון שלך עדיין לא הופעל. בדוק את תיבת הדואר ואשר את ההרשמה כדי להיכנס ל-ArChat.',
  'auth.pending_activation.back_to_login': 'חזרה לכניסה',
  'auth.pending_activation.support_prefix': 'צריך עזרה? צור קשר עם התמיכה:',
  "auth.pending_activation.support_email": "info@archat.com.ar",
  'auth.pending_activation.email_label': 'דוא\"ל לשליחה חוזרת של הפעלה',
  'auth.pending_activation.email_placeholder': 'אתה@email.com',
  'auth.pending_activation.email_required': 'הזן את כתובת הדוא\"ל שבה נרשמת כדי לשלוח שוב הפעלה.',
  'auth.pending_activation.sent_title': 'נשלח דוא\"ל הפעלה',
  'auth.pending_activation.sent_body': 'אם הכתובת תואמת חשבון ממתין, שלחנו קישור הפעלה חדש. בדוק תיבת דואר וספאם.',
  'auth.pending_activation.soft_error_title': 'שליחה חוזרת לא זמינה',
  'auth.pending_activation.soft_error_body': 'לא ניתן לעבד את השליחה החוזרת כעת. נסה שוב בעוד כמה דקות או צור קשר ב-info@archat.com.ar.',
  'auth.pending_activation.resend_again': 'שלח שוב',
  "plans.upgrade.title": "עדכון תוכנית",
  "plans.upgrade.comparison": "השוואת תוכניות",
  'plans.upgrade.billing': '',
  "plans.upgrade.cancel_anytime": "בטל מתי שתרצה",
  "plans.actions.upgrade_pro": "עבור ל-PRO",
  "plans.actions.become_founder": "הפוך למייסד",

  'plans.modal.card.current_badge': 'התוכנית הנוכחית שלך',

  'plans.modal.card.lower_tier': 'מתחת לתוכנית הפעילה שלך',

  'plans.modal.card.manage_in_profile': 'לשינוי או ביטול: מנוי וחיוב בפרופיל.',
                'plans.modal.card.cancel_subscription': 'ביטול מנוי',
                'plans.modal.cancel_confirm.title': 'ביטול או ניהול מנוי',
                'plans.modal.cancel_confirm.body': 'ייפתח טאב חדש עם פורטל Paddle המאובטח לעדכון תשלום, חשבוניות או ביטול מנוי.',
                'plans.modal.cancel_confirm.continue_button': 'המשך',
                'plans.modal.cancel_confirm.back_button': 'חזרה',
                'plans.modal.cancel_paddle_fallback.title': 'ניהול המנוי',
                'plans.modal.cancel_paddle_fallback.body': 'פורטל החיוב של Paddle לא נפתח בסביבה זו (למשל פיתוח מקומי או ללא קישור). אפשר להמשיך לצפות ולהשוות תוכניות כאן.',
                'plans.modal.cancel_paddle_fallback.confirm': 'הבנתי',
  "plans.upgrade_required": "זמין בתוכנית PRO",
  'settings.heading': 'הגדרות',
  'settings.dashboard': 'לוח',
  'settings.dashboardDescription': 'העדפות מקומיות ללוח הבית ולבלוקים הגלויים.',
  'settings.dashboardGridHeading': 'בלוקי הלוח',
  'settings.dashboardShowOnStartDescription': 'כשמופעל, לאחר הכניסה נפתח הלוח במקום רשימת אנשי קשר.',
  'settings.dashboardBlockWelcome': 'ברוך הבא',
  'settings.dashboardBlockUsage': 'שימוש בתוכנית',
  'settings.dashboardBlockFiles': 'הקבצים שלי',
  'settings.dashboardBlockPromotions': 'מבצעים',
  'settings.dashboardBlockSessions': 'סשנים',
  'settings.dashboardWelcomeDescription': 'צעדים ראשונים, הזמנת איש קשר וקיצורי דרך לעזרה.',
  'settings.dashboardUsageDescription': 'מול מגבלות: אנשי קשר, תווים, אחסון, מכשירים.',
  'settings.dashboardFilesDescription': 'סיכום קבצים ושטח ב"הקבצים שלי".',
  'settings.dashboardPromotionsDescription': 'תקציר מבצעים וקישור לתוכנית.',
  'settings.dashboardSessionsDescription': 'הפעלות ומכשירים פעילים; אפשר לסגור הפעלות אחרות אם קיימת.',
  'settings.enabled': 'פעיל',
  'settings.disabled': 'כבוי',
  'settings.showDashboardOnStart': 'הצגת הלוח בכניסה',
  'settings.showWelcomeBlock': 'בלוק ברוך הבא',
  'settings.showPromotionsBlock': 'בלוק מבצעים',
  'settings.showUsageBlock': 'שימוש בתוכנית',
  'settings.showRecentConversationsBlock': 'הצג שיחות אחרונות (הודעה אחרונה לכל איש קשר)',
  'settings.showSessionsBlock': 'הפעלות',
  'settings.showFilesBlock': 'סיכום קבצים',
  'settings.dashboardLocalNote': 'ההעדפות נשמרות בדפדפן (מקומי) עד שיהיה API פרופיל.',
  'settings.appearanceSettings': 'מראה',
  'settings.argentinaTheme': 'ערכת נושא ארגנטינה',
  'settings.darkMode': 'מצב כהה',
  'settings.language': 'שפה',
  'settings.messageSound': 'צליל הודעות',
  'settings.playSoundDescription': 'נגן צליל להודעות חדשות או התראות חשובות.',
  'settings.messageSoundEnabled': 'מופעל',
  'settings.messageSoundDisabled': 'כבוי',
  'settings.accountSettings': 'חשבון',
  'settings.deleteAccount': 'מחיקת חשבון',
  'settings.deleteAccountWarning': 'פעולה זו קבועה. הנתונים, ההודעות, אנשי הקשר וההגדרות יוסרו לפי תהליך המחיקה של הפלטפורמה.',
  'settings.deleteMyAccount': 'מחק את החשבון שלי',
  'dashboard.contacts': 'אנשי קשר',
  'dashboard.characters': 'תווים',
  'dashboard.storage': 'אחסון',
  'dashboard.active_devices': 'מכשירים פעילים',
  'dashboard.need_more_resources': 'צריך יותר משאבים?',
  'dashboard.upgrade_message': 'שדרג את התוכנית שלך כדי לקבל יותר אנשי קשר, תווים, אחסון ומכשירים פעילים.',
  'dashboard.upgrade_button': 'שדרג ל-PRO',
  'dashboard.upgrade_button_pro': 'שדרג ל-PRO',
  'dashboard.upgrade_button_foundation': 'שדרג ל-FOUNDATION',
  'files.preview': 'תצוגה מקדימה',
  'files.previewFile': 'תצוגה מקדימה של קובץ',
  'files.previewUnavailable': 'תצוגה מקדימה אינה זמינה.',
  'files.previewLoading': 'טוען תצוגה מקדימה…',
  'files.openPreview': 'תצוגה מקדימה',
  'files.downloadFile': 'הורדת קובץ',
  'files.downloadFailed': 'ההורדה נכשלה. בדקו חיבור וחשבון ונסו שוב.',
  'files.closePreview': 'סגור תצוגה מקדימה',
  'files.unsupportedPreview': 'אין תצוגה מקדימה לסוג קובץ זה. אפשר לראות פרטים או להוריד.',
  'files.pdfPreviewHelp': 'ייתכן שהדפדפן לא יציג PDF מוטמע. השתמש בהורדה לפתיחה.',
  'files.labelFileType': 'סוג',
  'files.previewForbidden': 'אין הרשאה לתצוגה מקדימה.',
  'files.previewNotFound': 'הקובץ אינו זמין או אינו מוצג עוד בחשבון.',
  'files.unavailableForFree': '״הקבצים שלי״ אינו כלול בתוכנית FREE.',
  'files.availableInFoundationAndPro': '״הקבצים שלי״ זמין בתוכניות FOUNDATION ו-PRO.',
  'files.filesFeatureRestricted': 'הפעולה אינה זמינה בתוכנית הנוכחית.',
  'files.filesLoadError': 'שגיאה בטעינת קבצים.',
  'files.uploadUnavailableForFree': 'שליחת קבצים אינה זמינה בתוכנית FREE.',
  'files.uploadAvailableInFoundationAndPro': 'שליחת קבצים זמינה ב-FOUNDATION וב-PRO.',
  'files.recipientStorageFull': 'לנמען אין מקום פנוי לקבל קובץ זה.',
  'files.recipientNoAvailableStorage': 'לנמען אין מקום פנוי לקבל קובץ זה.',
  'files.storageQuotaExceeded': 'הגעת למגבלת האחסון של התוכנית.',
  'files.freeStorageLimit': 'תוכנית FREE כוללת 5 MB לאחסון קבצים שהתקבלו.',
  'settings.unreadEmailReminderSection': 'סיכום לא נקרא במייל',
  'settings.unreadEmailReminderDescription': 'אם הודעות או קבצים חדשים נשארים שלא נקראו יותר מהזמן למטה, ArChat שולח מייל מסוכם אחד (לא לכל הודעה).',
  'settings.unreadEmailReminderToggle': 'שלחו לי סיכומים במייל',
  'settings.unreadEmailDelayHours': 'המתנה לפני שליחה (שעות)',
  'settings.unreadEmailDelayHint': '1–168 שעות (עד שבוע). שפת המייל לפי הפרופיל.',
  'subjects.title': 'נושאים',
  'subjects.singular': 'נושא',
  'subjects.plural': 'נושאים',
  'subjects.general': 'כללי',
  'subjects.new': 'נושא חדש',
  'subjects.create': 'יצירת נושא',
  'subjects.rename': 'שינוי שם',
  'subjects.finish': 'סיום',
  'subjects.reopen': 'פתיחה מחדש',
  'subjects.select': 'המשך',
  'subjects.status.open': 'פתוח',
  'subjects.status.pending': 'ממתין',
  'subjects.status.finished': 'הושלם',
  'subjects.limitReached': 'הגעת למגבלת הנושאים הפעילים בשיחה זו. סיים נושא כדי ליצור נושא חדש.',
  'subjects.limitReachedFree': 'תוכנית FREE: עד 3 נושאים פעילים לשיחה. סיים נושא כדי ליצור נושא חדש.',
  'subjects.limitReachedPro': 'תוכנית PRO: עד 5 נושאים פעילים לשיחה. סיים נושא כדי ליצור נושא חדש.',
  'subjects.limitReachedFoundation': 'תוכנית FOUNDATION: עד 5 נושאים פעילים לשיחה. סיים נושא כדי ליצור נושא חדש.',
  'subjects.activeLimitsLine': 'נושאים פעילים: {current} / {max}',
  'subjects.closedListTitle': 'נושאים סגורים',
  'subjects.viewClosed': 'הצג נושאים סגורים',
  'subjects.noClosedSubjects': 'אין נושאים סגורים.',
  'subjects.reopenSubject': 'פתח מחדש',
  'subjects.reopenedSubjects': 'נושאים שנפתחו מחדש',
  'subjects.reopenLimitReached':
    'הגעת למגבלת הנושאים הפעילים. סיים נושא אחר כדי לפתוח מחדש את זה.',
  'subjects.ownerOnlyReopen': 'רק מי שיצר את הנושא יכול לפתוח אותו מחדש.',
  'subjects.modal.title': 'נושאי השיחה',
  'subjects.modal.subtitle': 'בחר או נהל את נושאי השיחה.',
  'subjects.contactLabel': 'איש קשר:',
  'subjects.ownerOnlyRename': 'רק יוצר הנושא יכול לשנות את השם.',
  'subjects.ownerOnlyStateChange': 'רק יוצר הנושא יכול לשנות את הסטטוס.',
  'subjects.createdByOther': 'נושא זה נוצר על ידי הצד השני. תוכל להשיב אך לא לשנות את השם.',
  'subjects.empty': 'אין נושאים להצגה.',
  'subjects.noResults': 'לא נמצאו נושאים.',
  'subjects.error.generic': 'לא ניתן להשלים את הפעולה. נסה שוב.',
  'subjects.error.featureDisabled': 'נושאים אינם זמינים בסביבה זו.',
  'subjects.error.duplicateName': 'כבר קיים נושא פעיל בשם זה.',
  'subjects.error.ownerRequired': 'אין לך הרשאה לשנות נושא זה.',
  'subjects.error.defaultCannotRename': 'לא ניתן לשנות את שם הנושא הכללי.',
  'subjects.error.defaultCannotFinish': 'לא ניתן לסיים את הנושא הכללי.',
  'subjects.current': 'נושא',
  'subjects.change': 'שנה נושא',
  'subjects.currentLabel': 'נושא:',
  'subjects.changeSubject': 'שנה נושא',
  'subjects.closedCannotSend': 'הנושא הזה הסתיים. פתח אותו מחדש כדי לשלוח הודעות חדשות.',
  'subjects.selectBeforeSend': 'בחר נושא בחלון כדי לראות הודעות ולשלוח.',
  'subjects.loadingMessages': 'טוען הודעות לנושא זה…',
  'subjects.messageFilterError': 'לא ניתן לטעון הודעות לנושא זה.',
  ...PRESET_LOCALES.he,
  "auth.login.clear_password_lock_after_reset": "כבר שיניתי את הסיסמה שלי (למשל במכשיר אחר)",
  "auth.signup_disabled": "רישום חשבון חדש מושבת באופן זמני בסביבה זו.",
  "auth.reset_user_not_found": "לא מצאנו חשבון המשויך לאימייל הזה. בדוק שהוא מאוית נכון או צור חשבון חדש.",
  "account.not_found": "החשבון לא נמצא.",
  "menu.plans": "תוכניות",
  "files.title": "הקבצים שלי",
  "files.filter_all": "כֹּל",
  "files.filter_sent": "נשלח",
  "files.filter_received": "התקבל",
  "files.filter_images": "תמונות",
  "files.filter_documents": "מסמכים",
  "files.col_name": "שֵׁם",
  "files.col_size": "גוֹדֶל",
  "files.col_date": "תַאֲרִיך",
  "files.col_direction": "דיר.",
  "files.col_actions": "פעולות",
  "files.sent": "📤 נשלח",
  "files.received": "📥 התקבל",
  "files.download": "פְּרִיקָה",
  "files.delete_for_me": "מחק בשבילי",
  "files.delete_confirm_title": "מחק קובץ",
  "files.delete_confirm_message": "קובץ זה יימחק מחשבונך. זה לא יימחק עבור האדם השני. לְהַמשִׁיך?",
  "files.empty": "אין לך קבצים.",
  "files.error_loading": "שגיאה בהעלאת קבצים.",
  "files.load_more": "טען עוד",
  "message.status.sending": "שְׁלִיחָה…",
  "message.status.failed": "לא נשלח",
  "message.status.sent": "נשלח",
  "message.status.delivered": "נמסר",
  "message.status.read": "לִקְרוֹא",
  "home.public_nav.pricing": "מחירים",
  "home.public_nav.aria": "ניווט ראשי באתר",
  "home.public_footer.aria": "קישורים משפטיים",
  "home.pricing_link": "תוכניות ומחירים",
  "publicPricing.nav.back_home": "← בית",
  "publicPricing.title": "תוכניות ומחירים",
  "publicPricing.subtitle": "מגבלות שקופות ומיושרות למנוע המנויים של ArChat. מחירים מסחריים בדולר ארה\"ב עבור תשלום בינלאומי (למשל Paddle).",
  "publicPricing.commercial_note": "גבולות פונקציונליים מגיעים מ-PlanConstants/PlanResolver; החשבון שלך יכול להחיל plan_limits במסד הנתונים. טעינת הסוחר משתמשת ב-Paddle (או במעבדים אחרים שהוגדרו רשמית על ידי ArChat) עם תמחור בדולר ארה\"ב כפי שצוין.",
  "publicPricing.plan.free": "FREE",
  "publicPricing.plan.foundation": "FOUNDATION",
  "publicPricing.plan.pro": "PRO",
  "publicPricing.price.free": "USD 0 / mes",
  "publicPricing.price.foundation": "USD {price} / mes",
  "publicPricing.price.pro": "USD {price} / mes",
  "publicPricing.same_limits_pro": "אותן מגבלות טכניות כמו PRO (חוזה פרימיום).",
  "publicPricing.same_limits_foundation": "אותן מגבלות טכניות כמו FOUNDATION (חוזה פרימיום).",
  "publicPricing.badge.foundation": "Programa Founder",
  "publicPricing.badge.pro": "Recomendado",
  "publicPricing.free.b1": "30,000 תווים בחודש לכל חשבון.",
  "publicPricing.free.b2": "עד 2 אנשי קשר לכל משתמש; עד 2 שיחות פעילות לכל חשבון.",
  "publicPricing.free.b3": "אין קבצים מצורפים או שטח אחסון; ללא ייצוא נתונים.",
  "publicPricing.free.b4": "היסטוריית הודעות עד 30 יום; מכשיר אחד למשתמש.",
  "publicPricing.free.b5": "34 הודעות ליום ו-1,000 הודעות לחודש (דייר); עד 20 הזמנות ביום.",
  "publicPricing.premium.b1": "300,000 תווים בחודש לכל חשבון; עד 100 אנשי קשר למשתמש.",
  "publicPricing.premium.b2": "שיחות וצ'אטים ללא הגבלה (דייר); 1,667 הודעות ליום ו-50,000 לחודש.",
  "publicPricing.premium.b3": "עד 50 MB של אחסון (דייר); עד 3 מכשירים למשתמש.",
  "publicPricing.premium.b4": "הזמנות ללא הגבלה (דייר); ייצוא, תרגום אוטומטי וקבצים לפי תוכנית.",
  "publicPricing.premium.b5": "קרן: אותו חוזה טכני כמו PRO, בתוספת תוכנית מייסד (150 מקומות). יתרונות: סטנדרט פרימיום.",
  "publicPricing.foundation.founder_note": "תוכנית מסחרית של מייסד: מספר מוגבל של {משבצות} מקומות (ראה סיכום תוכנית). אותן מגבלות PRO לאחר הפעלת המנוי.",
  "publicPricing.cta.start_free": "צור חשבון בחינם",
  "publicPricing.cta.register_paid": "צור חשבון",
  "publicPricing.paddle_hint": "התשלום עם המעבד הנבחר תושלם בתוך האפליקציה כאשר הטעינה מופעלת.",
  "publicPricing.legal.nav_label": "מִשׁפָּטִי",
  "publicPricing.legal.terms": "תנאי שירות",
  "publicPricing.legal.privacy": "מדיניות פרטיות",
  "publicPricing.legal.refund": "מדיניות החזר כספי",
  "profile.security.privacy_note": "נהל את הפרטיות והאבטחה של חשבונך.",
  "profile.security.sessions_title": "הפעלות פעילות",
  "profile.security.current": "מושב נוכחי",
  "profile.plan.foundation.description": "תוכנית FOUNDATION (מייסד): שימוש פרימיום זהה לזה של PRO, עם תוכנית Founder ומקום מוגבל (150 מושבים).",
  "billing.view_plans": "ראה תוכניות",
  "billing.paddle.cancel_via_portal": "בטל מנוי",
  "billing.paddle.test_access_denied_body": "בשרת זה, פעולות החיוב מוגבלות (מצב בדיקה או רשימת בדיקה). אם כבר שילמת עם חשבון אמיתי, בהפקה יש לאפשר את התשלום עבור כל המשתמשים (למשל PAYMENTS_ALLOW_ALL_BILLING_USERS) או שיש לבטל את ההגבלה הזו. צור קשר עם התמיכה.",
  "attachment.storage_insufficient_precheck.title": "לא מספיק מקום",
  "attachment.storage_insufficient_precheck.message": "הקובץ שוקל {fileSizeMb} MB ויש לך רק {availableMb} MB זמין. פנה מקום או שפר את התוכנית שלך כדי להמשיך.",
  "attachment.files_disabled.title": "מגבלת תוכנית",
  "attachment.files_disabled.message": "התוכנית הנוכחית שלך לא כוללת שליחת קבצים. שפר את התוכנית שלך כדי להמשיך.",
  "contacts.viewContactInfo": "צפה בפרטי התקשרות",
  "contacts.contactInfoTitle": "פרטי יצירת קשר",
  "contacts.phone": "טֵלֵפוֹן",
  "contacts.bio": "בִּיוֹגְרַפִיָה",
  "contacts.notProvided": "חסר מידע",
  "contacts.unread.badge": "הודעות שלא נקראו",
  "dashboard.recentInbound.title": "הודעות אחרונות שהתקבלו",
  "dashboard.recentInbound.empty": "אין לך הודעות שהתקבלו לאחרונה.",
  "dashboard.recentInbound.error": "לא ניתן היה לטעון הודעות.",
  "dashboard.recentInbound.previewPhoto": "תַצלוּם",
  "dashboard.recentInbound.previewFile": "ארכיון",
  "dashboard.recentInbound.previewPdf": "PDF",
  "dashboard.recentInbound.previewUnavailable": "ההודעה לא זמינה",
  "dashboard.recentInbound.readTitle": "לִקְרוֹא",
  "dashboard.recentInbound.unreadTitle": "לא נקרא",
  "dashboard.recentConversations.title": "שיחות אחרונות",
  "dashboard.recentConversations.empty": "אין שיחות להראות.",
  "dashboard.recentConversations.error": "לא ניתן היה לטעון שיחות.",
  "dashboard.plan.foundation": "FOUNDATION",
  "plan.errors.translationNotAllowed.title": "תרגום אינו זמין",
  "plan.errors.translationNotAllowed.message": "התוכנית הנוכחית שלך לא כוללת תרגום אוטומטי בין שפות.",
  "plan.errors.translationNotAllowed.solution": "כדי להשתמש בתרגום אוטומטי, שדרג את התוכנית שלך.",
  "billing.subscription.cancel_scheduled_date": "המנוי שלך מתוכנן לבטל בתאריך {{date}}. אתה יכול להמשיך להשתמש בתוכנית שלך עד אז.",
  "billing.subscription.cancel_scheduled_badge": "בוטל בתאריך {{date}}",
  "billing.scheduled.plan_after_cancel_label": "תכנון בסוף התקופה:",
  "billing.scheduled.plan_free": "FREE (gratuito)",
  "billing.scheduled.plan_foundation": "FOUNDATION",
  "billing.scheduled.switch_to_foundation": "שנה ל-FOUNDATION",
  "billing.scheduled.switch_to_free": "שנה ל-FREE",
  "billing.scheduled.foundation_full_title": "FOUNDATION אינו זמין",
  "billing.scheduled.foundation_full_message": "אין מקומות פנויים ל-FOUNDATION בשלב זה. התוכנית שלך תרד לחינם בסוף התקופה.",
  "billing.scheduled.saving": "חִסָכוֹן...",
  "billing.scheduled.error_title": "שגיאה בעת שינוי תוכנית",
  "billing.scheduled.error_generic": "לא ניתן היה לשנות את התוכנית המתוכננת. נסה שוב.",
  "billing.cancel_scheduled.title": "ביטול מתוכנן",
  "billing.cancel_scheduled.desc": "המנוי שלך יבוטל בתאריך {{date}}. אתה יכול להמשיך להשתמש בתוכנית הנוכחית שלך עד אז.",
  "billing.cancel_scheduled.no_new_plan_until_end": "עד שיפוג תוקף המנוי הזה לא תוכל להתקשר לתוכנית אחרת.",
  "billing.cancel_scheduled.free_fallback": "אם לא תחדש שום תוכנית, החשבון שלך ימשיך בחינם עם המגבלות המתאימות.",
  "billing.cancel_scheduled.profile_deactivation_hint": "אתה יכול גם לבטל את הרישום מהפלטפורמה מהפרופיל שלך.",
  "billing.cancel_scheduled.default_free": "בסוף התקופה: בחינם",
  "google.missing_client_id": "הכניסה של Google אינה זמינה במבנה הזה: VITE_GOOGLE_CLIENT_ID (או googleClientId לכל דייר ב-__ARCHAT_TENANT_CONFIG__) חסר.",
  "reviews.title": "ArChat ביקורות",
  "reviews.create_title": "איך היית מדרג את ArChat?",
  "reviews.edit_title": "ערוך את הביקורת שלי",
  "reviews.comment_placeholder": "ספר לנו על החוויה שלך (לא חובה)...",
  "reviews.submit_btn": "שלח ביקורת",
  "reviews.update_btn": "לְעַדְכֵּן",
  "reviews.thank_you": "תודה על הביקורת שלך!",
  "reviews.submitted_message": "דעתך עוזרת לנו להשתפר.",
  "reviews.error_select_rating": "בחר דירוג",
  "reviews.error_generic": "שגיאה בהגשת ביקורת",
  "reviews.prompt_message": "האם אתה אוהב את ArChat? השאר את הביקורת שלך!",
  "reviews.rate_now": "מתאימים",
  "reviews.later": "מְאוּחָר יוֹתֵר",
  "reviews.write_review": "כתוב ביקורת",
  "reviews.edit_my_review": "ערוך את הביקורת שלי",
  "reviews.no_reviews": "אין עדיין ביקורות. תהיה הראשון!",
  "reviews.review_singular": "סְקִירָה",
  "reviews.review_plural": "ביקורות",
  "reviews.verified": "מְאוּמָת",
  "reviews.anonymous": "אֲנוֹנִימִי",
  "files.storageUsed": "שטח משומש",
  "files.planQuota": "תכנן מכסה",
  "files.availableStorage": "זָמִין",
  "files.usagePercent": "מְשׁוּמָשׁ",
  "files.unlimited": "בִּלתִי מוּגבָּל",
  "files.sentBy": "נשלח על ידי",
  "files.unknownUser": "מִשׁתַמֵשׁ",
  "settings.webPushSection": "התראות מערכת (דחיפה/PWA)",
  "settings.webPushDescription": "מאפשר התראות כאשר האפליקציה ברקע או סגורה בנייד. דורש מפתח ציבורי VAPID ב-build (VITE_VAPID_PUBLIC_KEY) ומפתחות בשרת. הפעל את הרשאת הדפדפן ורשום את המכשיר הזה.",
  "settings.webPushButton": "הפעל הודעות דחיפה",
  "settings.webPushRegistering": "נרשם...",
  "settings.webPushState.granted": "ניתנה רשות. אם VAPID מוגדר כהלכה, היומן נשלח לשרת.",
  "settings.webPushState.denied": "הרשות נדחתה. אנא הפעל התראות עבור אתר זה בהגדרות הדפדפן שלך.",
  "settings.webPushState.default": "הקש על הכפתור כדי לבקש הרשאה ולרשום את המכשיר.",
  "settings.webPushState.unsupported": "דפדפן זה אינו תומך בהודעות דחיפה.",
  "settings.webPushVapidMissing": "VITE_VAPID_PUBLIC_KEY חסר במבנה הקצה הזה: לא ניתן להשלים מנוי בדחיפה.",
  "tags.etiquetas": "תוויות",
  "tags.manageTitle": "נהל תגים",
  "tags.manage": "🏷️ תגיות",
  "tags.allTags": "כל התגים",
  "tags.confirmDelete": "להסיר את התג הזה?",
  "tags.tagNamePlaceholder": "שם תג",
  "tags.create": "לִיצוֹר",
  "tags.noTags": "אין תוויות. צור אחד למעלה.",
  "tags.save": "לִשְׁמוֹר",
  "tags.edit": "לַעֲרוֹך",
  "tags.delete": "לְחַסֵל",
  "tags.assignTo": "הקצה ל",
  "tags.noTagsToAssign": "אין תוויות זמינות. תחילה צור אותם.",
  "tags.bgColor": "צבע רקע",
  "tags.textColor": "צבע טקסט",
  "tags.selectTag": "בחר תווית",
  "templates.selectTitle": "תבניות",
  "templates.noTemplates": "אין תבניות. צור אחד למעלה.",
  "templates.manage": "נהל תבניות",
  "templates.confirmDelete": "למחוק את התבנית הזו?",
  "templates.manageTitle": "נהל תבניות",
  "templates.titlePlaceholder": "כותרת התבנית",
  "templates.bodyPlaceholder": "כתבתי את הודעת התבנית...",
  "templates.create": "צור תבנית",
  "templates.save": "לִשְׁמוֹר",
  "templates.edit": "לַעֲרוֹך",
  "templates.delete": "לְחַסֵל",
};


